import React, { useEffect, useMemo, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../../../examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import Grid from "@mui/material/Grid";
// Büyük sayfada her tuşta tüm sayfanın yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Alert from "@mui/material/Alert";
import MenuItem from "@mui/material/MenuItem";
import { Autocomplete } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import tr from "date-fns/locale/tr";
import MDDropzone from "../../../../../components/MDDropzone";
import UploadedFilePreview from "components/MDDropzone/UploadedFilePreview";
import CrudService from "services/cruds-service";
import LocationHistory from "./LocationHistory";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import Fade from "@mui/material/Fade";
import Zoom from "@mui/material/Zoom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import Tooltip from "@mui/material/Tooltip";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import ViewShipments from "../crm/invoice";
import { appAlert } from "components/AppDialog";
import { FinanceKpi, FinancialSummaryPanel, KpiStrip, formatMoney, formatQuantity, formatPercent, profitTone, profitLabel } from "components/MblSummary";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});
const renderPartyCell = (value) => {
    const text = value || "-";

    return (
        <Tooltip title={text} arrow placement="top">
            <span
                style={{
                    display: "inline-block",
                    maxWidth: "250px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                }}
            >
                {text.length > 25 ? `${text.substring(0, 25)}...` : text}
            </span>
        </Tooltip>
    );
};

function safeNumber(v) {const n = Number(v);return Number.isFinite(n) ? n : 0;}
function formatNumber(v, digits = 4) {return Number(v || 0).toFixed(digits);}
function normalizeStringField(value) {
    if (Array.isArray(value)) {
        return value[0] ?? "";
    }
    return value ?? "";
}

const getProfitColor = (value) => {
    const n = Number(value || 0);
    if (n > 0) return "success";
    if (n === 0) return "warning";
    return "error";
};

function convertCurrency(amount, fromCurrency, toCurrency, rates) {
    const value = safeNumber(amount);

    if (!value) return 0;
    if (!fromCurrency || !toCurrency) return value;
    if (fromCurrency === toCurrency) return value;
    if (!rates) return value;

    if (fromCurrency === "USD") {
        return value * safeNumber(rates[toCurrency]);
    }

    if (toCurrency === "USD") {
        return value / safeNumber(rates[fromCurrency]);
    }

    const inUsd = value / safeNumber(rates[fromCurrency]);
    return inUsd * safeNumber(rates[toCurrency]);
}

const initialAddressState = {
    additionalInfo: "",
    gateway: "",
    country: "",
    city: "",
    district: "",
    latLong: "",
    zipcode: "",
    officeCode: "",
    brokerageName: "",
    pickupType: "Direct Pickup",
    deliveryType: "Direct Delivery",
    serviceProvider: "",
};

function MapClicker({ onPick }) {
    useMapEvents({
        click(e) {
            onPick(e.latlng);
        },
    });
    return null;
}

function SectionCard({ title, subtitle, children, rightAction }) {
    return (
        <Card
            sx={{
                mb: 3,
                p: { xs: 2, md: 2.75 },
                borderRadius: "22px",
                border: "1px solid rgba(148,163,184,0.22)",
                background:
                    "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(248,250,252,0.92))",
                boxShadow: "0 18px 45px rgba(15,23,42,0.07)",
                overflow: "hidden",
                position: "relative",
                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 4,
                    background: "linear-gradient(90deg, #0ea5e9, #2563eb, #22c55e)",
                },
            }}
        >
            <MDBox
                mb={2}
                display="flex"
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", md: "center" }}
                flexDirection={{ xs: "column", md: "row" }}
                gap={1.5}
            >
                <MDBox>
                    <MDTypography variant="h6" fontWeight="bold" sx={{ color: "#0f172a" }}>
                        {title}
                    </MDTypography>
                    {subtitle ? (
                        <MDTypography variant="caption" color="text" sx={{ maxWidth: 760, display: "block" }}>
                            {subtitle}
                        </MDTypography>
                    ) : null}
                </MDBox>
                {rightAction ? <MDBox>{rightAction}</MDBox> : null}
            </MDBox>

            <Divider sx={{ mb: 2, borderColor: "rgba(148,163,184,0.20)" }} />
            {children}
        </Card>
    );
}

function DocumentUploadCard({ title, files, setFiles, titleSx, wrapperSx, dzStyle }) {
    const uploaded = Boolean(files?.length);

    return (
        <Card
            sx={{
                p: 2,
                borderRadius: "18px",
                border: uploaded ? "1px solid rgba(34,197,94,0.32)" : "1px dashed rgba(148,163,184,0.45)",
                textAlign: "center",
                height: "100%",
                background: uploaded
                    ? "linear-gradient(145deg, rgba(240,253,244,0.92), rgba(255,255,255,0.96))"
                    : "linear-gradient(145deg, rgba(248,250,252,0.95), rgba(255,255,255,0.96))",
                boxShadow: "0 12px 30px rgba(15,23,42,0.06)",
                transition: "all 0.25s ease",
                "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 16px 38px rgba(15,23,42,0.09)",
                    borderColor: uploaded ? "rgba(34,197,94,0.55)" : "rgba(14,165,233,0.55)",
                },
            }}
        >
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
                <MDTypography variant="caption" fontWeight="bold" sx={{ ...titleSx, textAlign: "left", mb: 0 }}>
                    {title}
                </MDTypography>
                <Chip
                    size="small"
                    color={uploaded ? "success" : "default"}
                    label={uploaded ? "Uploaded" : "Pending"}
                    sx={{ fontWeight: "bold" }}
                />
            </MDBox>

            <MDBox
                sx={{
                    ...wrapperSx,
                    borderRadius: "16px",
                    backgroundColor: "rgba(255,255,255,0.78)",
                    border: "1px solid rgba(226,232,240,0.85)",
                }}
                mx="auto"
            >
                <MDDropzone
                    options={{
                        addRemoveLinks: true,
                        maxFilesize: 10000,
                        maxFiles: 1,
                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                        timeout: 0,
                    }}
                    onChange={(incomingFiles) => setFiles(incomingFiles)}
                    style={dzStyle}
                />
            </MDBox>

            <MDBox mt={1.5}>
                <UploadedFilePreview file={files} layout="stack" onRemove={() => setFiles([])} />
            </MDBox>
        </Card>
    );
}

function LocationPickerModal({open, title, initialCenter = { lat: 41.0082, lng: 28.9784 }, valueLatLng, onClose, onSelect}) {
    const [picked, setPicked] = useState(valueLatLng || null);
    const [searchText, setSearchText] = useState("");
    useEffect(() => {
        if (!open) return;
        const next = valueLatLng || null;
        // Prevent render loops: this effect should only react to prop changes.
        // (Avoid including `picked` in deps to prevent setState->effect->setState cycles.)
        const pickedTime = picked instanceof Date ? picked.getTime() : null;
        const nextTime = next instanceof Date ? next.getTime() : null;

        const isSame =
            next === picked ||
            (picked &&
                next &&
                typeof picked === "object" &&
                typeof next === "object" &&
                Number(picked.lat) === Number(next.lat) &&
                Number(picked.lng) === Number(next.lng)) ||
            (pickedTime !== null && nextTime !== null && pickedTime === nextTime);

        if (!isSame) setPicked(next);
    }, [valueLatLng, open]);

    const centerLat = Number.isFinite(picked?.lat) ? picked.lat : initialCenter.lat;
    const centerLng = Number.isFinite(picked?.lng) ? picked.lng : initialCenter.lng;

    const searchLocation = async () => {
        if (!searchText) return;

        try {
            const res = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchText)}`
            );

            const data = await res.json();

            if (data && data.length > 0) {
                const lat = parseFloat(data[0].lat);
                const lng = parseFloat(data[0].lon);
                setPicked({ lat, lng });
            } else {
                appAlert("Location not found");
            }
        } catch (err) {
            console.error("Search error:", err);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <MDBox mb={2} display="flex" gap={1}>
                    <TextField
                        label="Search City / Country / Zipcode"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                searchLocation();
                            }
                        }}
                        variant="outlined"
                        fullWidth
                    />

                    <MDButton variant="contained" color="info" onClick={searchLocation}>
                        Search
                    </MDButton>
                </MDBox>

                <MDBox sx={{ height: 420, width: "100%" }}>
                    <MapContainer
                        center={[centerLat, centerLng]}
                        zoom={6}
                        style={{ height: "100%", width: "100%" }}
                        key={`${centerLat}-${centerLng}`}
                    >
                        <TileLayer
                            attribution="&copy; OpenStreetMap contributors"
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />

                        <MapClicker onPick={(latlng) => setPicked(latlng)} />
                        {Number.isFinite(picked?.lat) && Number.isFinite(picked?.lng) && (
                            <Marker position={[picked.lat, picked.lng]} />
                        )}
                    </MapContainer>
                </MDBox>

                <MDBox mt={2} display="flex" gap={2}>
                    <TextField
                        label="Latitude"
                        value={picked?.lat ?? ""}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        variant="outlined"
                    />

                    <TextField
                        label="Longitude"
                        value={picked?.lng ?? ""}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        variant="outlined"
                    />
                </MDBox>

                <MDTypography variant="caption" color="text">
                    You can search a city, country or zipcode and then click on the map to refine the
                    location.
                </MDTypography>
            </DialogContent>

            <DialogActions>
                <MDButton variant="contained" color="dark" onClick={onClose}>
                    Cancel
                </MDButton>

                <MDButton
                    variant="contained"
                    color="success"
                    onClick={() => {
                        if (picked) onSelect(picked);
                    }}
                    disabled={!picked}
                >
                    Select
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}

const ConnectAMBL = ({ embedded = false, selectedShipments = [], embeddedAmblId = null }) => {    const location = useLocation();

    const navigate = useNavigate();
    const getVesselName = (obj = {}) =>
        obj?.vesselName || obj?.vessel || obj?.shipName || "";
    const getCutOffDate = (obj = {}) =>
        obj?.cutOffDate || obj?.customsDeclarationCutoffDate || null;

    const getCutOffTime = (obj = {}) =>
        obj?.cutOffTime || obj?.customsDeclarationCutoffTime || "";

    const amblIdFromUrl = useMemo(() => {
        if (embedded) return embeddedAmblId;
        const sp = new URLSearchParams(location.search);
        return sp.get("id");
    }, [embedded, embeddedAmblId, location.search]);

    const isEditMode = Boolean(amblIdFromUrl);

    const CURRENCY_OPTIONS = ["USD", "EUR", "GBP", "TRY"];
    const DEFAULT_LINE_OPTIONS = [
        { id: 1, name: "HAPAG LLOYD" }, { id: 2, name: "CMA CGM" }, { id: 3, name: "MAERSK" }, { id: 4, name: "ONE LINE" }, { id: 5, name: "MSC" }, { id: 6, name: "YANG MING" },
        { id: 7, name: "OOCL" }, { id: 8, name: "EVERGREEN" }, { id: 9, name: "SEALEAD" }, { id: 10, name: "WAN HAI" }, { id: 11, name: "MLH" }, { id: 12, name: "ECULINE" },
        { id: 13, name: "VANGUARD" }, { id: 14, name: "SHIPCO" }, { id: 15, name: "CATONI" }, { id: 16, name: "ZIM" }, { id: 17, name: "ARKAS LINE" }, { id: 18, name: "AKKON" }, { id: 19, name: "MEDKON" }, { id: 20, name: "TURKON" }, { id: 21, name: "ADMIRAL" },];
    const [serviceProviders, setServiceProviders] = useState([]);
    const [selectedLinehaulProvider, setSelectedLinehaulProvider] = useState(null);
    const [linehaulCost, setLinehaulCost] = useState("");
    const [linehaulCurrency, setLinehaulCurrency] = useState("EUR");
    const [totalCurrency, setTotalCurrency] = useState("EUR");
    const [exchangeRates, setExchangeRates] = useState(null);
    const [shipmentPricing, setShipmentPricing] = useState({});
    const [saving, setSaving] = useState(false);
    const [selectedShipmentsState, setSelectedShipmentsState] = useState(
        embedded ? selectedShipments : location.state?.selectedShipments || []
    );

    // Cost / Selling Rate currency: the one entered on the linked AHFL file(s) (selling rate,
    // else buying rate), not a default. A currency picked by hand on this page is kept.
    const totalCurrencyTouchedRef = useRef(false);
    const hflCurrency = useMemo(() => {
        const attrs = (selectedShipmentsState || []).map((shipment) => shipment?.attributes || {});
        const pick = (key) => attrs.map((attr) => attr[key]).find(Boolean);
        return pick("sellingRateCurrency") || pick("buyingRateCurrency") || "";
    }, [selectedShipmentsState]);

    useEffect(() => {
        if (hflCurrency && !totalCurrencyTouchedRef.current) setTotalCurrency(hflCurrency);
    }, [hflCurrency]);
    const hasData = selectedShipmentsState.length > 0;
    const isSingle = selectedShipmentsState.length === 1;
    const firstAttr = selectedShipmentsState?.[0]?.attributes || null;
    const [printDialogOpen, setPrintDialogOpen] = useState(false);
    const [selectedPrintType, setSelectedPrintType] = useState("original");
    const hasInitializedFromLocationRef = useRef(false);
    // Id of the AMBL created on this screen. Every action that saves first (print, invoice,
    // consolidation) must update that record after the first create instead of creating another.
    const createdAmblIdRef = useRef(null);
    const saveInFlightRef = useRef(null);
    const [amblNumber, setAmblNumber] = useState("");
    const [actualDeparture, setActualDeparture] = useState(null);
    const [actualDepartureTime, setActualDepartureTime] = useState("");
    const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState(null);
    const [estimatedDeliveryTime, setEstimatedDeliveryTime] = useState("");
    const [sealNumber, setSealNumber] = useState("");
    const [cmrNumber, setCmrNumber] = useState("");
    const [plateContainerNumber, setPlateContainerNumber] = useState("");
    const [t1t2, setT1t2] = useState([]);
    const [linehaulCarrier, setLinehaulCarrier] = useState([]);
    const [cmr, setCmr] = useState([]);
    const [pickupLocation, setPickupLocation] = useState(initialAddressState);
    const [deliveryLocation, setDeliveryLocation] = useState(initialAddressState);
    const [locationHistory, setLocationHistory] = useState([]);
    const [refreshLocationHistory, setRefreshLocationHistory] = useState(false);
    const [pickupDate, setPickupDate] = useState(null);
    const [pickupTime, setPickupTime] = useState("");
    const [cutOffDate, setCutOffDate] = useState(null);
    const [cutOffTime, setCutOffTime] = useState("");
    const [freeTime, setFreeTime] = useState("");
    const [vesselName, setVesselName] = useState("");
    const [transitTime, setTransitTime] = useState("");
    const [estimatedDeparture, setEstimatedDeparture] = useState(null);
    const [estimatedDepartureTime, setEstimatedDepartureTime] = useState("");
    const [proofOfDelivery, setProofOfDelivery] = useState(null);
    const [proofOfDeliveryTime, setProofOfDeliveryTime] = useState("");
    const [pickupPickerOpen, setPickupPickerOpen] = useState(false);
    const [deliveryPickerOpen, setDeliveryPickerOpen] = useState(false);
    const [lineOptions, setLineOptions] = useState([]);
    const [selectedLine, setSelectedLine] = useState(null);
    const ORIGINAL_FRONT_PDF = "/documents/cmr/air-mbl-seawaybill.pdf";
    const ORIGINAL_BACK_PDF = "/documents/cmr/original-back.pdf";
    const SEAWAYBILL_FRONT_PDF = "/documents/cmr/air-mbl-seawaybill.pdf";
    const SEAWAYBILL_BACK_PDF = "/documents/cmr/seawaybill-back.pdf";
    const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
    const [previewMergedPdfUrl, setPreviewMergedPdfUrl] = useState("");
    const [printLoading, setPrintLoading] = useState(false);
    const [documentTopRightNumber, setDocumentTopRightNumber] = useState("");
    const [service, setService] = useState("door_to_door");
    const [pickupAddress1, setPickupAddress1] = useState({ type: "", country: "", city: "", port: "" });
    const [pickupAddress2, setPickupAddress2] = useState({ type: "", country: "", city: "", port: "" });
    const [deliveryAddress1, setDeliveryAddress1] = useState({ type: "", country: "", city: "", port: "" });
    const [deliveryAddress2, setDeliveryAddress2] = useState({ type: "", country: "", city: "", port: "" });
    const [bookingResponsibleParty, setBookingResponsibleParty] = useState("");
    const [selectedBookingAgent, setSelectedBookingAgent] = useState(null);
    const [freightStatus, setFreightStatus] = useState("");
    const [originAgentEnabled, setOriginAgentEnabled] = useState("");
    const [selectedOriginAgent, setSelectedOriginAgent] = useState(null);
    const [originActualType, setOriginActualType] = useState("");
    const [destinationAgentEnabled, setDestinationAgentEnabled] = useState("");
    const [selectedDestinationAgent, setSelectedDestinationAgent] = useState(null);
    const [destinationActualType, setDestinationActualType] = useState("");
    const [othcCost, setOthcCost] = useState("");
    const [othcCurrency, setOthcCurrency] = useState("EUR");
    const [airFreightCost, setAirFreightCost] = useState("");
    const [airFreightCurrency, setAirFreightCurrency] = useState("EUR");
    const [dthcCost, setDthcCost] = useState("");
    const [dthcCurrency, setDthcCurrency] = useState("EUR");
    const [handlingCost, setHandlingCost] = useState("");
    const [handlingCurrency, setHandlingCurrency] = useState("EUR");
    const [rdlDate, setRdlDate] = useState(null);
    const [rdlTime, setRdlTime] = useState("");
    const [originalEtaDate, setOriginalEtaDate] = useState(null);
    const [delayReason, setDelayReason] = useState("");
    const [aadDate, setAadDate] = useState(null);
    const [aadTime, setAadTime] = useState("");
    const [notifyAgentEnabled, setNotifyAgentEnabled] = useState("");
    const [selectedNotifyAgent, setSelectedNotifyAgent] = useState(null);
    const [notifyActualType, setNotifyActualType] = useState("");
    const [invoiceDialogOpen, setInvoiceDialogOpen] = useState(false);
    const [invoiceState, setInvoiceState] = useState(null);
    const utikadNumberOptions = Array.from({ length: 19 }, (_, i) => {
        const number = 1233 + i;
        return {
            label: String(number).padStart(6, "0"),
        };
    });
    const getPrintDocumentsByType = (type) => {
        switch (type) {
            case "original":
                return [ORIGINAL_FRONT_PDF, ORIGINAL_BACK_PDF];
            case "seawaybill":
                return [SEAWAYBILL_FRONT_PDF, SEAWAYBILL_BACK_PDF];
            default:
                return [];
        }
    };

    const createMergedFilledPdf = async (type) => {
        const [frontPdfUrl, backPdfUrl] = getPrintDocumentsByType(type);

        if (!frontPdfUrl || !backPdfUrl) {
            throw new Error("Document templates not found.");
        }

        const filledFrontBytes = await createFilledFrontPdf(frontPdfUrl);

        const mergedPdf = await PDFDocument.create();

        const frontDoc = await PDFDocument.load(filledFrontBytes);
        const frontPages = await mergedPdf.copyPages(frontDoc, frontDoc.getPageIndices());
        frontPages.forEach((page) => mergedPdf.addPage(page));

        const backResponse = await fetch(backPdfUrl);
        if (!backResponse.ok) {
            throw new Error(`PDF alınamadı: ${backPdfUrl}`);
        }

        const backArrayBuffer = await backResponse.arrayBuffer();
        const backDoc = await PDFDocument.load(backArrayBuffer);
        const backPages = await mergedPdf.copyPages(backDoc, backDoc.getPageIndices());
        backPages.forEach((page) => mergedPdf.addPage(page));

        const mergedPdfBytes = await mergedPdf.save();
        return new Blob([mergedPdfBytes], { type: "application/pdf" });
    };

    const handlePreviewSelectedDocument = async () => {
        try {
            setPrintLoading(true);

            if (previewMergedPdfUrl) {
                URL.revokeObjectURL(previewMergedPdfUrl);
            }

            const blob = await createMergedFilledPdf(selectedPrintType);
            const blobUrl = URL.createObjectURL(blob);

            setPreviewMergedPdfUrl(blobUrl);
            setPrintDialogOpen(false);
            setPreviewDialogOpen(true);
        } catch (err) {
            console.error("Preview error:", err);
            appAlert("Preview could not be created. Please try again.");
        } finally {
            setPrintLoading(false);
        }
    };
    const handleDownloadSelectedDocument = async () => {
        try {
            setPrintLoading(true);

            const blob = await createMergedFilledPdf(selectedPrintType);
            const mergedUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = mergedUrl;
            link.download =
                selectedPrintType === "original"
                    ? "original-document.pdf"
                    : "seawaybill-document.pdf";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(mergedUrl);
            setPreviewDialogOpen(false);
            setPrintDialogOpen(false);
        } catch (err) {
            console.error("Download error:", err);
            appAlert("Document could not be downloaded. Please try again.");
        } finally {
            setPrintLoading(false);
        }
    };
    const handleClosePreviewDialog = () => {
        setPreviewDialogOpen(false);

        if (previewMergedPdfUrl) {
            URL.revokeObjectURL(previewMergedPdfUrl);
            setPreviewMergedPdfUrl("");
        }
    };

    useEffect(() => {
        return () => {
            if (previewMergedPdfUrl) {
                URL.revokeObjectURL(previewMergedPdfUrl);
            }
        };
    }, [previewMergedPdfUrl]);

    const handleCutOffDateChange = (nextValue) => {
        setCutOffDate((prev) => {
            if (prev === nextValue) return prev;

            const prevTime = prev instanceof Date ? prev.getTime() : null;
            const nextTime = nextValue instanceof Date ? nextValue.getTime() : null;

            if (prevTime !== null && nextTime !== null) {
                if (Number.isFinite(prevTime) && Number.isFinite(nextTime) && prevTime === nextTime)
                    return prev;
            }

            if (!nextValue) return null;

            if (nextValue instanceof Date && !Number.isFinite(nextTime)) return null;

            return nextValue;
        });
    };

    const fetchExchangeRates = async () => {
        try {
            const res = await fetch("https://api.exchangerate-api.com/v4/latest/USD");
            return await res.json();
        } catch (error) {
            console.error("API Error:", error);
            return null;
        }
    };

    function safeCurrency(v, fallback = "EUR") {return v || fallback;}

    useEffect(() => {
        const loadRates = async () => {
            const data = await fetchExchangeRates();
            if (data?.rates) {
                setExchangeRates(data.rates);
            }
        };
        loadRates();
    }, []);

    useEffect(() => {
        if (isEditMode) return;

        const fetchNextAmblNumber = async () => {
            try {
                const res = await CrudService.getNextAMBLNumber();
                const nextNumber =
                    res?.data?.attributes?.amblNumber || res?.data?.data?.attributes?.amblNumber || "AMBL0001";
                setAmblNumber(nextNumber);
            } catch (error) {
                setAmblNumber("AMBL0001");
            }
        };

        fetchNextAmblNumber();
    }, [isEditMode]);

    useEffect(() => {
        if (isEditMode) return;
        if (hasInitializedFromLocationRef.current) return;

        const stateShipments = location.state?.selectedShipments || [];
        if (stateShipments.length) {
            setSelectedShipmentsState(stateShipments);
            hasInitializedFromLocationRef.current = true;
        }
    }, [isEditMode, location.state]);

    useEffect(() => {
        if (!isEditMode) return;

        const run = async () => {
            try {
                const res = await CrudService.getAMBLById(amblIdFromUrl);
                const attr = res?.data?.data?.attributes || res?.data?.attributes || null;

                if (!attr) return;

                const snap = Array.isArray(attr.shipments) ? attr.shipments : [];

                const normalized = snap
                    .map((x) => {
                        if (x?.attributes) return x;
                        if (x?.id && x) return { id: x.id, attributes: x.attributes || x };
                        return null;
                    })
                    .filter(Boolean);

                const firstHflAttr = normalized?.[0]?.attributes || {};

                const savedEta = attr.eta || null;
                const hflEta = firstHflAttr.estimatedDeliveryDate || firstHflAttr.eta || null;

                const savedCob = attr.cob || null;
                const hflCob = firstHflAttr.actualDeparture || firstHflAttr.cob || null;

                const savedCutOffDate = getCutOffDate(attr);
                const hflCutOffDate = getCutOffDate(firstHflAttr);

                const savedCutOffTime = getCutOffTime(attr);
                const hflCutOffTime = getCutOffTime(firstHflAttr);

                const savedVesselName = getVesselName(attr);
                const hflVesselName = getVesselName(firstHflAttr);

                setSelectedShipmentsState(normalized);

                setAmblNumber(attr.amblNumber || "AMBL0001");

                setPickupDate(attr.pickupDate ? new Date(attr.pickupDate) : null);
                setPickupTime(attr.pickupTime || "");

                setProofOfDelivery(attr.proofOfDelivery ? new Date(attr.proofOfDelivery) : null);
                setProofOfDeliveryTime(attr.proofOfDeliveryTime || "");

                setActualDeparture(savedCob ? new Date(savedCob) : hflCob ? new Date(hflCob) : null);
                setActualDepartureTime(attr.cobTime || firstHflAttr.actualDepartureTime || firstHflAttr.cobTime || "");
                setAadDate(attr.aadDate ? new Date(attr.aadDate) : null);
                setAadTime(attr.aadTime || "");
                setEstimatedDeliveryDate(savedEta ? new Date(savedEta) : hflEta ? new Date(hflEta) : null);
                setNotifyAgentEnabled(attr.notifyAgentEnabled || "");
                setSelectedNotifyAgent(attr.selectedNotifyAgent?.id ? attr.selectedNotifyAgent : null);
                setNotifyActualType(attr.notifyActualType || "");
                setOriginalEtaDate(
                    attr.originalEtaDate
                        ? new Date(attr.originalEtaDate)
                        : hflEta
                            ? new Date(hflEta)
                            : savedEta
                                ? new Date(savedEta)
                                : null
                );

                setEstimatedDeliveryTime(attr.etaTime || firstHflAttr.estimatedDeliveryTime || firstHflAttr.etaTime || "");

                setRdlDate(attr.rdlDate ? new Date(attr.rdlDate) : null);
                setRdlTime(attr.rdlTime || "");
                setDelayReason(attr.delayReason || "");

                setCutOffDate(
                    savedCutOffDate
                        ? new Date(savedCutOffDate)
                        : hflCutOffDate
                            ? new Date(hflCutOffDate)
                            : null
                );

                setCutOffTime(savedCutOffTime || hflCutOffTime || "");

                setFreeTime(attr.freeTime ?? "");
                setVesselName(savedVesselName || hflVesselName || "");
                setTransitTime(attr.transitTime ?? "");

                setSealNumber(attr.sealNumber || "");
                setCmrNumber(attr.cmrNumber || "");
                setPlateContainerNumber(attr.plateContainerNumber || "");

                // Backend bu alanları tekil string (dosya yolu) olarak saklar; state ise dizi bekler
                setT1t2(attr.t1t2 ? [attr.t1t2] : []);
                setLinehaulCarrier(attr.linehaulCarrier ? [attr.linehaulCarrier] : []);
                setCmr(attr.cmr ? [attr.cmr] : []);

                setPickupLocation({
                    ...initialAddressState,
                    ...(attr?.pickupLocation || {}),
                    additionalInfo: normalizeStringField(attr?.pickupLocation?.additionalInfo),
                });

                setDeliveryLocation({
                    ...initialAddressState,
                    ...(attr?.deliveryLocation || {}),
                    additionalInfo: normalizeStringField(attr?.deliveryLocation?.additionalInfo),
                });

                setLocationHistory(Array.isArray(attr.locationHistory) ? attr.locationHistory : []);

                setEstimatedDeparture(
                    attr.estimatedDeparture ? new Date(attr.estimatedDeparture) : null
                );
                setEstimatedDepartureTime(attr.estimatedDepartureTime || "");

                setShipmentPricing(attr.shipmentPricing || {});

                setSelectedLinehaulProvider(attr.airFreightDetails?.provider?.id ? attr.airFreightDetails.provider : null);
                setLinehaulCost(attr.airFreightDetails?.cost ?? "");
                setLinehaulCurrency(attr.airFreightDetails?.currency || "EUR");

                // The AHFL file's currency wins over the copy saved on this record.
                if (!hflCurrency) {
                    setTotalCurrency(attr.financialSummary?.totalCurrency || attr.freightCharges?.totalCurrency || "EUR");
                }

                const freightCharges = attr.freightCharges || {};
                const savedFinancialSummary = attr.financialSummary || {};

                setOthcCost(
                    freightCharges.othc?.cost ??
                    savedFinancialSummary.othcCost ??
                    ""
                );

                setOthcCurrency(
                    freightCharges.othc?.currency ||
                    savedFinancialSummary.othcCurrency ||
                    "EUR"
                );

                setAirFreightCost(
                    freightCharges.airFreight?.cost ??
                    attr.airFreightDetails?.cost ??
                    ""
                );

                setAirFreightCurrency(
                    freightCharges.airFreight?.currency ||
                    attr.airFreightDetails?.currency ||
                    "EUR"
                );

                setDthcCost(
                    freightCharges.dthc?.cost ??
                    savedFinancialSummary.dthcCost ??
                    ""
                );

                setDthcCurrency(
                    freightCharges.dthc?.currency ||
                    savedFinancialSummary.dthcCurrency ||
                    "EUR"
                );

                setHandlingCost(freightCharges.handling?.cost ?? "");
                setHandlingCurrency(freightCharges.handling?.currency || "EUR");

                setSelectedLine(attr.lineDetails?.line?.id ? attr.lineDetails.line : null);

                setBookingResponsibleParty(attr.bookingResponsibleParty || "");
                setSelectedBookingAgent(attr.selectedBookingAgent?.id ? attr.selectedBookingAgent : null);
                setFreightStatus(attr.freightStatus || "");

                setOriginAgentEnabled(attr.originAgentEnabled || "");
                setSelectedOriginAgent(attr.selectedOriginAgent?.id ? attr.selectedOriginAgent : null);
                setOriginActualType(attr.originActualType || "");

                setDestinationAgentEnabled(attr.destinationAgentEnabled || "");
                setSelectedDestinationAgent(attr.selectedDestinationAgent?.id ? attr.selectedDestinationAgent : null);
                setDestinationActualType(attr.destinationActualType || "");
            } catch (err) {
                console.error("getAMBLById error:", err?.response?.data || err);
                appAlert("MBL could not be loaded. Please try again.");
            }
        };

        run();
    }, [isEditMode, amblIdFromUrl]);
    const hasInitializedRef = useRef(false);
    const resolvedCutOffDate = getCutOffDate(firstAttr);

    useEffect(() => {
        if (isEditMode) return;
        if (!firstAttr) return;
        if (hasInitializedRef.current) return;

        setPickupLocation({
            ...initialAddressState,
            ...(firstAttr.pickupLocation || {}),
            additionalInfo: normalizeStringField(firstAttr.pickupLocation?.additionalInfo),
        });
        setDeliveryLocation({
            ...initialAddressState,
            ...(firstAttr.deliveryLocation || {}),
            additionalInfo: normalizeStringField(firstAttr.deliveryLocation?.additionalInfo),
        });
        setPickupDate(firstAttr.pickupDate ? new Date(firstAttr.pickupDate) : null);
        setPickupTime(firstAttr.pickupTime || "");
        setCutOffDate(resolvedCutOffDate ? new Date(resolvedCutOffDate) : null);
        setCutOffTime(getCutOffTime(firstAttr));
        setVesselName(getVesselName(firstAttr));
        setFreeTime(firstAttr.freeTime ?? "");
        setDocumentTopRightNumber(firstAttr.documentTopRightNumber || "");
        setTransitTime(firstAttr.transitTime ?? "");
        setEstimatedDeparture(firstAttr.estimatedDeparture ? new Date(firstAttr.estimatedDeparture) : null);
        setEstimatedDepartureTime(firstAttr.estimatedDepartureTime || "");
        setEstimatedDeliveryDate(firstAttr.estimatedDeliveryDate ? new Date(firstAttr.estimatedDeliveryDate) : null);
        setEstimatedDeliveryTime(firstAttr.estimatedDeliveryTime || "");
        setActualDeparture(firstAttr.actualDeparture ? new Date(firstAttr.actualDeparture) : null);
        setActualDepartureTime(firstAttr.actualDepartureTime || "");
        setProofOfDelivery(firstAttr.proofOfDelivery ? new Date(firstAttr.proofOfDelivery) : null);
        setProofOfDeliveryTime(firstAttr.proofOfDeliveryTime || "");
        setLocationHistory(firstAttr.locationHistory || []);

        hasInitializedRef.current = true;
    }, [firstAttr, isEditMode]);

    useEffect(() => {
        if (!selectedShipmentsState?.length) return;

        setShipmentPricing((prev) => {
            const next = { ...prev };

            selectedShipmentsState.forEach((shipment) => {
                const id = shipment?.id;
                const attr = shipment?.attributes || {};

                if (!id) return;

                if (!next[id]) {
                    next[id] = {
                        cost:
                            safeNumber(attr.buyingRate) +
                            safeNumber(attr.pickupRate) +
                            safeNumber(attr.deliveryRate) +
                            safeNumber(attr.exportCustomsRate) +
                            safeNumber(attr.importCustomsRate),
                        costCurrency:
                            attr.buyingRateCurrency ||
                            attr.pickupRateCurrency ||
                            attr.deliveryRateCurrency ||
                            attr.exportCustomsRateCurrency ||
                            attr.importCustomsRateCurrency ||
                            "EUR",
                        sellingRate: safeNumber(attr.finalSellingRate ?? attr.sellingRate),
                        baseSellingRate: safeNumber(attr.sellingRate),
                        finalSellingRate: safeNumber(attr.finalSellingRate ?? attr.sellingRate),
                        additionalFees: attr.additionalFees || [],
                        sellingRateCurrency: safeCurrency(attr.sellingRateCurrency, "EUR"),
                        profit: 0,
                        profitCurrency: totalCurrency,
                    };
                }
            });

            return next;
        });
    }, [selectedShipmentsState, totalCurrency]);

    useEffect(() => {
        const fetchServiceProviders = async () => {
            try {
                const response = await CrudService.getGlobalAgents();

                const options = (response?.data || []).map((item) => {
                    const attr = item.attributes || {};

                    return {
                        id: item.id,
                        name: attr.name || attr.companyName || "Unnamed Global Agent",
                        globalAgentCountry: attr.globalAgentCountry || "",
                        servicesCountry: attr.servicesCountry || [],
                        raw: attr,
                    };
                });

                setServiceProviders(options);
            } catch (error) {
                console.error("Global Agent verileri alınırken hata oluştu:", error);
                setServiceProviders([]);
            }
        };

        fetchServiceProviders();
    }, []);
    const linkTextSx = {
        cursor: "pointer",
        textDecoration: "underline",
        "&:hover": {
            opacity: 0.8,
        },
    };

    useEffect(() => {
        const fetchLines = async () => {
            try {
                const options = DEFAULT_LINE_OPTIONS;
                setLineOptions(options);
            } catch (error) {
                console.error("Lines verileri alınırken hata oluştu:", error);
                setLineOptions(DEFAULT_LINE_OPTIONS);
            }
        };

        fetchLines();
    }, []);

    const pricingComputed = useMemo(() => {
        const rows = selectedShipmentsState.map((s) => {
            const a = s.attributes || {};

            const pickupCost = safeNumber(a.pickupRate);
            const pickupCurrency = safeCurrency(a.pickupRateCurrency, "EUR");

            const deliveryCost = safeNumber(a.deliveryRate);
            const deliveryCurrency = safeCurrency(a.deliveryRateCurrency, "EUR");

            const sellingRate = safeNumber(a.finalSellingRate ?? a.sellingRate);
            const baseSellingRate = safeNumber(a.sellingRate);
            const sellingRateCurrency = safeCurrency(a.sellingRateCurrency, "EUR");

            const additionalFees = Array.isArray(a.additionalFees) ? a.additionalFees : [];

            const cost =
                convertCurrency(pickupCost, pickupCurrency, totalCurrency, exchangeRates) +
                convertCurrency(deliveryCost, deliveryCurrency, totalCurrency, exchangeRates);

            return {
                id: s.id,
                shipmentNo: `AHFL${a.shipmentNo || 0}`,
                pickupCost,
                pickupCurrency,
                deliveryCost,
                deliveryCurrency,
                cost,
                costCurrency: totalCurrency,
                sellingRate,
                baseSellingRate,
                finalSellingRate: sellingRate,
                additionalFees,
                sellingRateCurrency,
            };
        });

        const pickupTotal = rows.reduce(
            (acc, row) =>
                acc + convertCurrency(row.pickupCost, row.pickupCurrency, totalCurrency, exchangeRates),
            0
        );

        const deliveryTotal = rows.reduce(
            (acc, row) =>
                acc + convertCurrency(row.deliveryCost, row.deliveryCurrency, totalCurrency, exchangeRates),
            0
        );

        const sellingTotal = rows.reduce(
            (acc, row) =>
                acc + convertCurrency(row.sellingRate, row.sellingRateCurrency, totalCurrency, exchangeRates),
            0
        );

        const othcTotal = convertCurrency(othcCost, othcCurrency, totalCurrency, exchangeRates);
        const airFreightTotal = convertCurrency(
            airFreightCost,
            airFreightCurrency,
            totalCurrency,
            exchangeRates
        );
        const dthcTotal = convertCurrency(dthcCost, dthcCurrency, totalCurrency, exchangeRates);
        const handlingTotal = convertCurrency(handlingCost, handlingCurrency, totalCurrency, exchangeRates);

        const buyingRate =
            pickupTotal +
            othcTotal +
            airFreightTotal +
            dthcTotal +
            handlingTotal +
            deliveryTotal;

        const totalProfit = sellingTotal - buyingRate;

        const rowsWithProfit = rows.map((row) => ({
            ...row,
            profit: totalProfit / (rows.length || 1),
            profitCurrency: totalCurrency,
        }));

        return {
            rows: rowsWithProfit,
            pickupTotal,
            othcTotal,
            airFreightTotal,
            dthcTotal,
            handlingTotal,
            deliveryTotal,
            buyingRate,
            shipmentCostTotal: pickupTotal + deliveryTotal,
            shipmentSellingTotal: sellingTotal,
            totalProfit,
        };
    }, [
        selectedShipmentsState,
        totalCurrency,
        exchangeRates,
        othcCost,
        othcCurrency,
        airFreightCost,
        airFreightCurrency,
        dthcCost,
        dthcCurrency,
        handlingCost,
        handlingCurrency,
    ]);

    const financialSummary = useMemo(() => ({
        pickupTotal: pricingComputed.pickupTotal,
        othcTotal: pricingComputed.othcTotal,
        airFreightTotal: pricingComputed.airFreightTotal,
        dthcTotal: pricingComputed.dthcTotal,
        handlingTotal: pricingComputed.handlingTotal,
        deliveryTotal: pricingComputed.deliveryTotal,
        buyingRate: pricingComputed.buyingRate,
        totalSellingRate: pricingComputed.shipmentSellingTotal,
        totalProfit: pricingComputed.totalProfit,
    }), [pricingComputed]);


    const computed = useMemo(() => {
        const rows = selectedShipmentsState.map((s) => {
            const a = s.attributes || {};
            const totals = a.totals || {};
            const cargo = Array.isArray(a.cargoDetails) ? a.cargoDetails : [];

            const grossFromCargo = cargo.reduce((sum, c) => sum + safeNumber(c?.grossWeight), 0);

            const grossWeight =
                safeNumber(totals.totalGrossWeight) ||
                safeNumber(totals.grossWeight) ||
                grossFromCargo;

            const unitFromCargo = cargo.reduce(
                (sum, c) => sum + safeNumber(c?.unitQuantity || c?.pcs || c?.quantity),
                0
            );

            const unit = safeNumber(totals.totalUnit) || safeNumber(totals.totalPcs) || unitFromCargo;

            const shipper =
                a.shipper?.companyName ||
                a.shipper?.name ||
                a.shipper ||
                a.pickupLocation?.companyName ||
                a.pickupLocation?.name ||
                "N/A";

            const consignee =
                a.consignee?.companyName ||
                a.consignee?.name ||
                a.consignee ||
                a.deliveryLocation?.companyName ||
                a.deliveryLocation?.name ||
                "N/A";

            return {
                id: s.id,
                shipmentNo: `AHFL${a.shipmentNo || 0}`,
                grossWeight,
                unit,
                shipper,
                consignee,
            };
        });

        const totals = rows.reduce(
            (acc, r) => {
                acc.grossWeight += safeNumber(r.grossWeight);
                acc.unit += safeNumber(r.unit);
                return acc;
            },
            { grossWeight: 0, unit: 0 }
        );

        return { rows, totals };
    }, [selectedShipmentsState]);

    const profitMargin = useMemo(() => {
        if (!safeNumber(financialSummary.totalSellingRate)) return 0;
        return (safeNumber(financialSummary.totalProfit) / safeNumber(financialSummary.totalSellingRate)) * 100;
    }, [financialSummary.totalProfit, financialSummary.totalSellingRate]);

    const pricingTable = {
        columns: [
            { Header: () => <b>Shipment No</b>, accessor: "shipmentNo" },
            { Header: () => <b>Cost</b>, accessor: "cost" },
            { Header: () => <b>Selling Rate</b>, accessor: "sellingRate" },
            { Header: () => <b>Profit</b>, accessor: "profit" },
        ],
        rows: [
            ...pricingComputed.rows.map((row) => ({
                shipmentNo: (
                    <MDTypography
                        variant="caption"
                        fontWeight="bold"
                        color="info"
                        sx={linkTextSx}
                        onClick={() => handleGoShipmentForm(row.id)}
                    >
                        {row.shipmentNo}
                    </MDTypography>
                ),
                cost: `${formatNumber(row.cost, 2)} ${row.costCurrency}`,
                sellingRate: `${formatNumber(row.sellingRate, 2)} ${row.sellingRateCurrency}`,
                profit: (
                    <span style={{ fontWeight: 700 }}>
                        <MDTypography
                            variant="caption"
                            fontWeight="bold"
                            color={getProfitColor(row.profit)}
                        >
                            {formatNumber(row.profit, 2)} {row.profitCurrency}
                        </MDTypography>
                    </span>
                ),            })),
            {
                shipmentNo: <strong>TOTAL</strong>,
                cost: (
                    <strong>
                        {formatNumber(pricingComputed.shipmentCostTotal, 2)} {totalCurrency}
                    </strong>
                ),
                sellingRate: (
                    <strong>
                        {formatNumber(pricingComputed.shipmentSellingTotal, 2)} {totalCurrency}
                    </strong>
                ),
                profit: (
                    <strong>
                        <MDTypography
                            variant="caption"
                            fontWeight="bold"
                            color={getProfitColor(pricingComputed.totalProfit)}
                        >
                            {formatNumber(pricingComputed.totalProfit, 2)} {totalCurrency}
                        </MDTypography>
                    </strong>
                ),
            },
        ],
    };

    const totalsTable = {
        columns: [
            { Header: () => <b>Shipment No</b>, accessor: "shipmentNo" },
            { Header: () => <b>Gross Weight</b>, accessor: "grossWeight" },
            { Header: () => <b>Unit</b>, accessor: "unit" },
        ],
        rows: [
            ...computed.rows.map((r) => ({
                shipmentNo: (
                    <MDTypography
                        variant="caption"
                        fontWeight="bold"
                        color="info"
                        sx={linkTextSx}
                        onClick={() => handleGoShipmentForm(r.id)}
                    >
                        {r.shipmentNo}
                    </MDTypography>
                ),
                grossWeight: formatNumber(r.grossWeight, 4),
                unit: formatNumber(r.unit, 0),
            })),
            {
                shipmentNo: <strong>TOTAL</strong>,
                grossWeight: <strong>{formatNumber(computed.totals.grossWeight, 4)}</strong>,
                unit: <strong>{formatNumber(computed.totals.unit, 0)}</strong>,
            },
        ],
    };
    const FILENDERS_NAME = "FILENDERS LOGISTICS AND TECHNOLOGY";

    const getFirstShipmentAttr = () => {
        return selectedShipmentsState?.[0]?.attributes || {};
    };

    const getBookingNumber = (attr = {}) =>
        attr.bookingNumber ||
        attr.bookingNo ||
        attr.bookingConfirmationNo ||
        attr.bookingReference ||
        "";

    const getContainerType = (attr = {}) => {
        const cargo = Array.isArray(attr.cargoDetails) ? attr.cargoDetails : [];
        return (
            attr.containerType ||
            attr.selectedContainerType ||
            cargo.find((x) => x?.containerType)?.containerType ||
            ""
        );
    };

    const getContainerNumber = (attr = {}) => {
        const cargo = Array.isArray(attr.cargoDetails) ? attr.cargoDetails : [];
        return (
            attr.containerNo ||
            attr.containerNumber ||
            attr.plateContainerNumber ||
            cargo.find((x) => x?.containerNo)?.containerNo ||
            ""
        );
    };

    const getSealNumber = (attr = {}) => {
        const cargo = Array.isArray(attr.cargoDetails) ? attr.cargoDetails : [];

        return (
            attr.sealNumber ||
            attr.sealNo ||
            cargo.find((x) => x?.sealNumber)?.sealNumber ||
            cargo.find((x) => x?.sealNo)?.sealNo ||
            ""
        );
    };

    const getHflReferenceRows = () =>
        selectedShipmentsState.map((shipment) => {
            const attr = shipment?.attributes || {};

            return {
                id: shipment.id,
                hNumber: attr.shipmentNo ? `AHFL${attr.shipmentNo}` : "-",
                bookingNumber: getBookingNumber(attr) || "-",
                containerType: getContainerType(attr) || "-",
                containerNumber: getContainerNumber(attr) || "-",
                sealNumber: getSealNumber(attr) || "-",
                vesselName: getVesselName(attr) || "-",
                cob: attr.actualDeparture || attr.cob || null,
                eta: attr.estimatedDeliveryDate || attr.eta || null,
                cutoff: getCutOffDate(attr),
            };
        });

    const hasEtaDelay = useMemo(() => {
        if (!originalEtaDate || !estimatedDeliveryDate) return false;

        const original = new Date(originalEtaDate).setHours(0, 0, 0, 0);
        const current = new Date(estimatedDeliveryDate).setHours(0, 0, 0, 0);

        return current > original;
    }, [originalEtaDate, estimatedDeliveryDate]);
    const normalizeText = (value) =>
        String(value || "")
            .trim()
            .toLowerCase();

    const normalizeCountryList = (value) => {
        if (!value) return [];

        if (Array.isArray(value)) {
            return value
                .map((item) => {
                    if (typeof item === "string") return item;
                    return item?.label || item?.name || item?.country || "";
                })
                .filter(Boolean);
        }

        if (typeof value === "object") {
            return [value.label || value.name || value.country || ""].filter(Boolean);
        }

        return [value].filter(Boolean);
    };

    const countryMatches = (agentCountries, targetCountry) => {
        const normalizedTarget = normalizeText(targetCountry);

        if (!normalizedTarget) return false;

        return agentCountries.some(
            (country) => normalizeText(country) === normalizedTarget
        );
    };

    const getAgentName = (agent) => {
        const raw = agent?.raw || agent?.attributes || agent || {};
        return agent?.name || raw.name || raw.companyName || "";
    };

    const getAgentCountries = (agent) => {
        const raw = agent?.raw || agent?.attributes || agent || {};

        return [
            ...normalizeCountryList(agent?.globalAgentCountry),
            ...normalizeCountryList(agent?.servicesCountry),
            ...normalizeCountryList(raw.globalAgentCountry),
            ...normalizeCountryList(raw.servicesCountry),
        ].filter(Boolean);
    };

    const getPolCountry = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.vesselPol?.country ||
            first?.polCountry ||
            first?.POLCountry ||
            first?.pol?.country ||
            first?.pickupAddress2?.country ||
            first?.pickupAddress1?.country ||
            first?.pickupLocation?.country ||
            ""
        );
    };

    const getPodCountry = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.vesselPod?.country ||
            first?.podCountry ||
            first?.PODCountry ||
            first?.pod?.country ||
            first?.deliveryAddress1?.country ||
            first?.deliveryAddress2?.country ||
            first?.deliveryLocation?.country ||
            ""
        );
    };

    const getActualShipper = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.shipper?.companyName ||
            first?.shipper?.name ||
            first?.shipper ||
            ""
        );
    };

    const getActualConsignee = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.consignee?.companyName ||
            first?.consignee?.name ||
            first?.consignee ||
            ""
        );
    };

    const getActualNotify = () => {
        const first = getFirstShipmentAttr();

        return (
            first?.notify?.companyName ||
            first?.notify?.name ||
            first?.notify ||
            ""
        );
    };

    const handleEtaDateChange = (nextValue) => {
        setEstimatedDeliveryDate(nextValue);

        if (!originalEtaDate && nextValue) {
            setOriginalEtaDate(nextValue);
        }
    };

    const polCountry = getPolCountry();
    const podCountry = getPodCountry();

    const filterAgentsByCountry = (targetCountry) => {
        if (!targetCountry) return [];

        return serviceProviders.filter((agent) => {
            const countries = getAgentCountries(agent);
            return countryMatches(countries, targetCountry);
        });
    };

    const originAgentOptions = useMemo(() => {
        return filterAgentsByCountry(polCountry);
    }, [serviceProviders, polCountry]);


    const destinationAgentOptions = useMemo(() => {
        return filterAgentsByCountry(podCountry);
    }, [serviceProviders, podCountry]);

    const notifyAgentOptions = destinationAgentOptions;

    const finalMblShipper = useMemo(() => {
        if (originAgentEnabled === "YES") {
            return getAgentName(selectedOriginAgent);
        }

        if (originAgentEnabled === "NO") {
            if (originActualType === "FILENDERS") return FILENDERS_NAME;
            if (originActualType === "ACTUAL") return getActualShipper();
        }

        return "";
    }, [
        originAgentEnabled,
        selectedOriginAgent,
        originActualType,
        selectedShipmentsState,
    ]);

    const finalMblConsignee = useMemo(() => {
        if (destinationAgentEnabled === "YES") {
            return getAgentName(selectedDestinationAgent);
        }

        if (destinationAgentEnabled === "NO") {
            if (destinationActualType === "FILENDERS") return FILENDERS_NAME;
            if (destinationActualType === "ACTUAL") return getActualConsignee();
        }

        return "";
    }, [
        destinationAgentEnabled,
        selectedDestinationAgent,
        destinationActualType,
        selectedShipmentsState,
    ]);

    const finalMblNotify = useMemo(() => {
        if (notifyAgentEnabled === "YES") {
            return getAgentName(selectedNotifyAgent);
        }

        if (notifyAgentEnabled === "NO") {
            if (notifyActualType === "FILENDERS") return FILENDERS_NAME;
            if (notifyActualType === "ACTUAL") return getActualNotify();
            if (notifyActualType === "SAME_AS_CONSIGNEE") return finalMblConsignee;
        }

        return "";
    }, [
        notifyAgentEnabled,
        selectedNotifyAgent,
        notifyActualType,
        finalMblConsignee,
        selectedShipmentsState,
    ]);
    const partiesTable = {
        columns: [
            { Header: () => <b>Shipment No</b>, accessor: "shipmentNo" },
            { Header: () => <b>Actual Shipper</b>, accessor: "shipper" },
            { Header: () => <b>Actual Consignee</b>, accessor: "consignee" },
            { Header: () => <b>Actual Notify</b>, accessor: "notify" },
            { Header: () => <b>Final MBL Shipper</b>, accessor: "finalMblShipper" },
            { Header: () => <b>Final MBL Consignee</b>, accessor: "finalMblConsignee" },
            { Header: () => <b>Final MBL Notify</b>, accessor: "finalMblNotify" },
        ],
        rows: computed.rows.map((r) => ({
            shipmentNo: (
                <MDTypography
                    variant="caption"
                    fontWeight="bold"
                    color="info"
                    sx={linkTextSx}
                    onClick={() => handleGoShipmentForm(r.id)}
                >
                    {r.shipmentNo}
                </MDTypography>
            ),
            shipper: renderPartyCell(r.shipper),
            consignee: renderPartyCell(r.consignee),
            notify: renderPartyCell(getActualNotify()),
            finalMblShipper: (
                <MDTypography variant="button" fontWeight="bold" color="info">
                    {renderPartyCell(finalMblShipper)}
                </MDTypography>
            ),

            finalMblConsignee: (
                <MDTypography variant="button" fontWeight="bold" color="success">
                    {renderPartyCell(finalMblConsignee)}
                </MDTypography>
            ),

            finalMblNotify: (
                <MDTypography variant="button" fontWeight="bold" color="warning">
                    {renderPartyCell(finalMblNotify)}
                </MDTypography>
            ),
        })),    };

    const buildInvoicePayloadFromAmbl = () => {
        const shipments = selectedShipmentsState || [];

        if (!Array.isArray(shipments) || shipments.length === 0) return null;

        // Was missing every cost field entirely -- the invoice preview's
        // Cost column always showed 0 regardless of what this AMBL's own
        // Financial Summary (pickup/othc/air freight/dthc/delivery +
        // buying rate) actually totaled, because there was nothing here
        // for the invoice page to read it from. Mirrors the equivalent
        // fallback cascade already used for Road (Consolidation.js).
        const canUseAmblTotal = shipments.length === 1;
        const amblOperationalCost =
            safeNumber(financialSummary.pickupTotal) +
            safeNumber(financialSummary.othcTotal) +
            safeNumber(financialSummary.airFreightTotal) +
            safeNumber(financialSummary.dthcTotal) +
            safeNumber(financialSummary.handlingTotal) +
            safeNumber(financialSummary.deliveryTotal);
        // buyingRate is already the total of these parts (see pricingComputed), not extra.
        const amblTotalCost = Math.max(amblOperationalCost, safeNumber(financialSummary.buyingRate));

        const formattedShipments = shipments.map((s, idx) => {
            const row = s?.attributes || s;
            const rowFinancialSummary = row.financialSummary || {};

            // Each cost candidate keeps the currency it is in: the AMBL total is in this page's
            // Total Currency, not in the shipment's buying currency.
            const rowCurrency = row.buyingRateCurrency || rowFinancialSummary.totalCurrency || totalCurrency || "";
            const summaryCurrency = rowFinancialSummary.totalCurrency || rowCurrency;
            const [totalCost, costCurrency] = [
                [row.totalCost, rowCurrency],
                [row.actualCostTotal, rowCurrency],
                [row.expectedCostTotal, rowCurrency],
                [row.operationalCost, rowCurrency],
                [row.buyingRate, rowCurrency],
                [rowFinancialSummary.totalCost, summaryCurrency],
                [rowFinancialSummary.operationalCost, summaryCurrency],
                [rowFinancialSummary.buyingRate, summaryCurrency],
                [canUseAmblTotal ? amblTotalCost : 0, totalCurrency || rowCurrency],
            ]
                .map(([value, currency]) => [safeNumber(value), currency])
                .find(([value]) => value > 0) || [0, rowCurrency];

            return {
                shipmentNo: row.shipmentNo,
                customer: row.customer,
                sellingRateCurrency: row.sellingRateCurrency,
                // Full selling amount: base rate plus the shipment's additional fees.
                sellingRate: safeNumber(row.finalSellingRate ?? row.sellingRate),
                finalSellingRate: safeNumber(row.finalSellingRate ?? row.sellingRate),
                profit: row.profit || 0,
                totals: row.totals || {},
                carbonFootprint: row.carbonFootprint || {},
                cargoDetails: row.cargoDetails || [],
                financialSummary: rowFinancialSummary,
                costCurrency,
                totalCostCurrency: costCurrency,
                totalCost,
                actualCostTotal: totalCost,
                expectedCostTotal: totalCost,
                operationalCost: totalCost,
                totalCostIncludesBuyingRate: true,
                _id: row._id || row.id || s.id || `${idx}`,
            };
        });

        const linehaulServiceProviderMap = {};

        shipments.forEach((s) => {
            const row = s?.attributes || s;
            const key = `AHFL${row.shipmentNo || ""}`;

            linehaulServiceProviderMap[key] =
                row.serviceProvider ||
                selectedLinehaulProvider?.name ||
                selectedLinehaulProvider ||
                "N/A";
        });

        return {
            formattedShipments,
            linehaulServiceProviderMap,
        };
    };
    const saveAmblToBackend = async () => {
        const formData = new FormData();
        const shipmentCount = selectedShipmentsState.length || 1;
        const distributedProfit = safeNumber(financialSummary.totalProfit) / shipmentCount;

        const shipmentPricingForSave = { ...shipmentPricing };

        selectedShipmentsState.forEach((shipment) => {
            const id = shipment?.id;
            if (!id) return;

            shipmentPricingForSave[id] = {
                ...shipmentPricingForSave[id],
                profit: distributedProfit,
                profitCurrency: totalCurrency,
            };
        });
        const payload = {
            shipments: selectedShipmentsState.map((s) => {
                const attr = s.attributes || {};

                return {
                    id: s.id,
                    attributes: {
                        ...attr,
                        sellingRate: attr.sellingRate,
                        baseSellingRate: attr.baseSellingRate ?? attr.sellingRate,
                        finalSellingRate: attr.finalSellingRate ?? attr.sellingRate,
                        additionalFees: attr.additionalFees || [],
                    },
                };
            }),
            amblNumber,

            pickupDate,
            pickupTime,
            proofOfDelivery,
            proofOfDeliveryTime,

            cob: actualDeparture,
            cobTime: actualDepartureTime,
            eta: estimatedDeliveryDate,
            etaTime: estimatedDeliveryTime,

            cutOffDate,
            cutOffTime,
            freeTime,
            vesselName,
            transitTime,
            originalEtaDate,
            rdlDate,
            rdlTime,
            aadDate,
            aadTime,
            delayReason: hasEtaDelay || Boolean(delayReason) ? delayReason : "",
            documentTopRightNumber,
            sealNumber,
            cmrNumber,
            plateContainerNumber,
            bookingResponsibleParty,
            freightStatus,

            originAgentEnabled,
            originActualType,

            destinationAgentEnabled,
            destinationActualType,

            finalMblShipper,
            finalMblConsignee,
            lineDetails: {
                line: selectedLine,
            },
            pickupLocation: {
                ...pickupLocation,
                additionalInfo: normalizeStringField(pickupLocation?.additionalInfo),
            },
            deliveryLocation: {
                ...deliveryLocation,
                additionalInfo: normalizeStringField(deliveryLocation?.additionalInfo),
            },

            locationHistory,
            shipmentPricing: shipmentPricingForSave,
            airFreightDetails: {
                provider: {
                    id: selectedLinehaulProvider?.id || "",
                    name: selectedLinehaulProvider?.name || "",
                },
                cost: safeNumber(linehaulCost),
                currency: linehaulCurrency,
            },
            selectedBookingAgent: {
                id: selectedBookingAgent?.id || "",
                name: getAgentName(selectedBookingAgent),
                globalAgentCountry: selectedBookingAgent?.globalAgentCountry || "",
                servicesCountry: normalizeCountryList(selectedBookingAgent?.servicesCountry),
            },

            selectedOriginAgent: {
                id: selectedOriginAgent?.id || "",
                name: getAgentName(selectedOriginAgent),
                globalAgentCountry: selectedOriginAgent?.globalAgentCountry || "",
                servicesCountry: normalizeCountryList(selectedOriginAgent?.servicesCountry),
            },

            selectedDestinationAgent: {
                id: selectedDestinationAgent?.id || "",
                name: getAgentName(selectedDestinationAgent),
                globalAgentCountry: selectedDestinationAgent?.globalAgentCountry || "",
                servicesCountry: normalizeCountryList(selectedDestinationAgent?.servicesCountry),
            },
            financialSummary: {
                pickupTotal: safeNumber(financialSummary.pickupTotal),
                othcTotal: safeNumber(financialSummary.othcTotal),
                airFreightTotal: safeNumber(financialSummary.airFreightTotal),
                dthcTotal: safeNumber(financialSummary.dthcTotal),
                handlingTotal: safeNumber(financialSummary.handlingTotal),
                deliveryTotal: safeNumber(financialSummary.deliveryTotal),
                buyingRate: safeNumber(financialSummary.buyingRate),
                totalSellingRate: safeNumber(financialSummary.totalSellingRate),
                totalProfit: safeNumber(financialSummary.totalProfit),
                totalCurrency,
            },
            freightCharges: {
                pickupTotal: safeNumber(financialSummary.pickupTotal),
                othc: {
                    cost: safeNumber(othcCost),
                    currency: othcCurrency,
                    total: safeNumber(financialSummary.othcTotal),
                },
                airFreight: {
                    cost: safeNumber(airFreightCost),
                    currency: airFreightCurrency,
                    total: safeNumber(financialSummary.airFreightTotal),
                },
                dthc: {
                    cost: safeNumber(dthcCost),
                    currency: dthcCurrency,
                    total: safeNumber(financialSummary.dthcTotal),
                },
                handling: {
                    cost: safeNumber(handlingCost),
                    currency: handlingCurrency,
                    total: safeNumber(financialSummary.handlingTotal),
                },
                deliveryTotal: safeNumber(financialSummary.deliveryTotal),
                buyingRate: safeNumber(financialSummary.buyingRate),
                totalCurrency
            },
            notifyAgentEnabled,
            notifyActualType,
            finalMblNotify,
            billOfLadingType: embedded ? "DIRECT_BL" : "HBL",
            isDirectBL: Boolean(embedded),
            sourceType: embedded ? "DBL" : "AMBL",

            selectedNotifyAgent: {
                id: selectedNotifyAgent?.id || "",
                name: getAgentName(selectedNotifyAgent),
                globalAgentCountry:
                    selectedNotifyAgent?.globalAgentCountry || "",
                servicesCountry:
                    normalizeCountryList(
                        selectedNotifyAgent?.servicesCountry
                    ),
            },
        };
        formData.append("data", JSON.stringify(payload));

        if (t1t2?.[0]) formData.append("t1t2", t1t2[0]);
        if (linehaulCarrier?.[0]) formData.append("linehaulCarrier", linehaulCarrier[0]);
        if (cmr?.[0]) formData.append("cmr", cmr[0]);

        const existingId = amblIdFromUrl || createdAmblIdRef.current;
        if (existingId) {
            await CrudService.updateAMBL(formData, existingId);
            return existingId;
        }

        const res = await CrudService.createAMBL(formData);
        const created = res?.data?.id ? res.data : res?.data?.data;
        if (created?.id) createdAmblIdRef.current = created.id;
        // The backend assigns the real number on create; show that one from now on.
        if (created?.attributes?.amblNumber) setAmblNumber(created.attributes.amblNumber);
        return created?.id;
    };

    // Rapid double clicks share one request instead of each creating a record.
    const saveAmblToBackendOnce = () => {
        if (!saveInFlightRef.current) {
            saveInFlightRef.current = saveAmblToBackend().finally(() => {
                saveInFlightRef.current = null;
            });
        }
        return saveInFlightRef.current;
    };

    const handleGoToConsolidation = async () => {
        try {
            setSaving(true);
            const amblId = await saveAmblToBackendOnce();

            navigate("/air-shipping-order/shipment-consolidation/consolidation", {
                state: {
                    fromAmbl: true,
                    amblId ,
                },
            });
        } catch (err) {
            console.error("AMBL save error:", err?.response?.data || err);
            appAlert("AMBL could not be saved. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    const TITLE_SX = {
        fontWeight: "bold",
        lineHeight: 1.15,
        minHeight: 40,
        mb: 1,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "center",
    };

    const DROPZONE_WRAPPER_SX = {
        width: "100%",
        maxWidth: "120px",
        height: "130px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    const DZ_STYLE = {
        height: "90px",
        minHeight: "90px",
        maxHeight: "90px",
        fontSize: "8px",
        overflow: "hidden",
    };

    const FIELD_SX = {
        "& .MuiOutlinedInput-root": {
            minHeight: 56,
            boxSizing: "border-box",
            borderRadius: "10px",
            backgroundColor: "#fff",
            alignItems: "center",
            paddingRight: "39px !important",

            "& input": {
                padding: "16.5px 14px",
                boxSizing: "border-box",
            },

            "& fieldset": {
                top: 0,
            },
        },

        "& .MuiInputBase-root": {
            boxSizing: "border-box",
        },

        "& .MuiInputBase-input": {
            boxSizing: "border-box",
        },

        "& .MuiAutocomplete-inputRoot": {
            paddingTop: "0 !important",
            paddingBottom: "0 !important",
            minHeight: "56px",
            alignItems: "center",
        },

        "& .MuiAutocomplete-input": {
            padding: "7.5px 4px !important",
            minWidth: "0 !important",
        },

        "& .MuiAutocomplete-endAdornment": {
            top: "50%",
            transform: "translateY(-50%)",
        },

        "& .MuiInputLabel-root": {
            zIndex: 1,
            backgroundColor: "#fff",
            padding: "0 4px",
        },

        "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)",
        },
    };

    const deliveryLatLng = useMemo(() => {
        const str = deliveryLocation?.latLong || "";
        const [lat, lng] = str.split(",").map((x) => Number(String(x).trim()));
        if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
        return null;
    }, [deliveryLocation?.latLong]);
    const handleGoAmblForm = () => {
        if (!amblIdFromUrl) return;
        navigate(`/air-shipping-order/connect-ambl?id=${amblIdFromUrl}`);
    };

    const handleGoShipmentForm = (shipmentId) => {
        if (!shipmentId) return;
        navigate(`/shipping-order/create-air-shipment/details?id=${shipmentId}`);
    };

    const getAirTransportModeLabel = () => {
        const first = getFirstShipmentAttr();
        return first?.airTransportType || "";
    };

    const isLclOperation = () => {
        const mode = String(getAirTransportModeLabel() || "").toUpperCase();
        return mode.includes("LCL");
    };

    const isFclOperation = () => {
        const mode = String(getAirTransportModeLabel() || "").toUpperCase();
        return mode.includes("FCL");
    };

    useEffect(() => {
        const first = getFirstShipmentAttr?.() || {};
        setService(first?.service || "door_to_door");
        setPickupAddress1(first?.pickupAddress1 || { type: "", country: "", city: "", port: "" });
        setPickupAddress2(first?.pickupAddress2 || { type: "", country: "", city: "", port: "" });
        setDeliveryAddress1(first?.deliveryAddress1 || { type: "", country: "", city: "", port: "" });
        setDeliveryAddress2(first?.deliveryAddress2 || { type: "", country: "", city: "", port: "" });
    }, [selectedShipmentsState]);

    const buildAhflNumberList  = () => {
        return (selectedShipmentsState || [])
            .map((s) => {
                const no = s?.attributes?.shipmentNo;
                return no ? `AHFL${no}` : null;
            })
            .filter(Boolean);
    };

    const buildBaseShipmentPayloadFromAmbl = () => {
        const first = getFirstShipmentAttr();

        return {
            ...first,

            shipmentNo: first?.shipmentNo || "",
            airTransportType: first?.airTransportType || "",
            service: service || first?.service || "door_to_door",

            pickupAddress1: pickupAddress1 || first?.pickupAddress1 || { type: "", country: "", city: "", port: "" },
            pickupAddress2: pickupAddress2 || first?.pickupAddress2 || { type: "", country: "", city: "", port: "" },
            deliveryAddress1: deliveryAddress1 || first?.deliveryAddress1 || { type: "", country: "", city: "", port: "" },
            deliveryAddress2: deliveryAddress2 || first?.deliveryAddress2 || { type: "", country: "", city: "", port: "" },

            cmrNumber: cmrNumber || first?.cmrNumber || amblNumber || "",
            plateContainerNumber: plateContainerNumber || first?.plateContainerNumber || "",
            sealNumber: sealNumber || first?.sealNumber || "",

            pickupDate: pickupDate || first?.pickupDate || null,
            pickupTime: pickupTime || first?.pickupTime || "",

            estimatedDeparture: estimatedDeparture || first?.estimatedDeparture || null,
            estimatedDepartureTime: estimatedDepartureTime || first?.estimatedDepartureTime || "",

            estimatedDeliveryDate: estimatedDeliveryDate || first?.estimatedDeliveryDate || null,
            estimatedDeliveryTime: estimatedDeliveryTime || first?.estimatedDeliveryTime || "",

            actualDeparture: actualDeparture || first?.actualDeparture || null,
            actualDepartureTime: actualDepartureTime || first?.actualDepartureTime || "",

            proofOfDelivery: proofOfDelivery || first?.proofOfDelivery || null,
            proofOfDeliveryTime: proofOfDeliveryTime || first?.proofOfDeliveryTime || "",

            pickupLocation: {
                ...(first?.pickupLocation || {}),
                ...(pickupLocation || {}),
            },
            deliveryLocation: {
                ...(first?.deliveryLocation || {}),
                ...(deliveryLocation || {}),
            },

            serviceProvider:
                selectedLinehaulProvider?.name ||
                selectedLinehaulProvider ||
                first?.serviceProvider ||
                "",
        };
    };

    const buildMergedCargoDetailsForMultiLtl = () => {
        return (selectedShipmentsState || []).flatMap((shipment) => {
            const cargoList = Array.isArray(shipment?.attributes?.cargoDetails)
                ? shipment.attributes.cargoDetails
                : [];

            return cargoList.map((cargo) => ({
                commodity: cargo?.commodity || "",
                description: cargo?.description || "",
                hsCode: cargo?.hsCode || "",
                selectedPackingType: cargo?.selectedPackingType || "",
                unitQuantity: cargo?.unitQuantity || "",
                grossWeight: cargo?.grossWeight || "",
                cbm: cargo?.cbm || "",
            }));
        });
    };
    const buildMapDeliveryPointLines = () => {
        const points = [];

        const mainDeliveryLabel = [
            deliveryLocation?.additionalInfo,
            [deliveryLocation?.zipcode, deliveryLocation?.district, deliveryLocation?.city]
                .filter(Boolean)
                .join(" "),
            deliveryLocation?.country,
        ]
            .filter(Boolean)
            .join(", ");

        if (deliveryLocation?.latLong || mainDeliveryLabel) {
            points.push({
                source: "main",
                label: mainDeliveryLabel || deliveryLocation?.latLong || "",
            });
        }

        const historyDeliveryPoints = (locationHistory || []).filter(
            (item) =>
                item?.type === "delivery" ||
                String(item?.eventType || "").toLowerCase().includes("delivery address")
        );

        historyDeliveryPoints.forEach((item) => {
            points.push({
                source: "history",
                label: item?.label || "",
            });
        });

        return points
            .filter((item) => item.label)
            .map((item, index) => `${index + 1} - ${item.label}`);
    };
    const buildMapPickupAddressText = () => {
        const pickupPoints = (locationHistory || []).filter(
            (item) =>
                item?.type === "pickup" ||
                item?.eventType === "Pickup Address" ||
                item?.eventType === "Pickup Location"
        );

        if (pickupPoints.length > 0) {
            return pickupPoints
                .map((item, index) => {
                    const label = item?.label || "";
                    return `PickupPOINT ${index + 1}${label ? ` - ${label}` : ""}`;
                })
                .join("\n");
        }

        const fallback = pickupLocation || getFirstShipmentAttr()?.pickupLocation || {};

        return [
            fallback.additionalInfo,
            [fallback.zipcode, fallback.district, fallback.city].filter(Boolean).join(" "),
            fallback.country,
        ]
            .filter(Boolean)
            .join("\n");
    };

    const buildMultiLclCmrPayload = () => {
        const ahflNumbers = buildAhflNumberList();
        const ahflText = ahflNumbers.length ? ahflNumbers.join("\n") : "";

        const deliveryPointLines = buildMapDeliveryPointLines();
        const pickupAddressText = buildMapPickupAddressText();
        const mergedCargoDetails = buildMergedCargoDetailsForMultiLtl();

        return {
            ...buildBaseShipmentPayloadFromAmbl(),

            // 1 ve 2
            shipper: ahflText,
            consignee: ahflText,

            // 3 -> haritadaki delivery addressler
            pickupLocation: {
                ...(pickupLocation || {}),
                additionalInfo: deliveryPointLines,
                zipcode: "",
                district: "",
                city: "",
                country: "",
            },

            // 4 -> haritadaki pickup address
            deliveryLocation: {
                ...(deliveryLocation || {}),
                additionalInfo: pickupAddressText,
                zipcode: "",
                district: "",
                city: "",
                country: "",
            },

            // 5 -> boş
            attachedDocuments: "",
            documentsAttached: "",

            // 6-12 -> tüm AHFL cargoDetails kalem kalem
            cargoDetails: mergedCargoDetails,

            // 13 -> boş
            billTo: "",
            notify: "",
            manufacturer: "",
            quoteNo: "",

            // 14 -> generateCmrPdf zaten sabit FREIGHT PREPAID basıyor

            // 15 -> boş
            profit: "",

            // 16 -> seçilen service provider
            serviceProvider:
                selectedLinehaulProvider?.name ||
                selectedLinehaulProvider ||
                "",

            // 17 -> FILENDERS LOGISTICS AND TECHNOLOGY
            customDetail: {
                customNote: "FILENDERS LOGISTICS AND TECHNOLOGY",
            },

            // 18 -> plate
            plateContainerNumber: plateContainerNumber || "",

            // 19 -> boş bırakmak için kaynak alanları temizle
            airTransportType: "",
            truckType: "",
            t1DeclarationNumber: "",
            sealNumber: "",
            adr: false,
            imco: "",

            // 20 -> boş bırakmak için tüm rate alanlarını temizle
            buyingRate: "",
            buyingRateCurrency: "",
            pickupRate: "",
            pickupRateCurrency: "",
            deliveryRate: "",
            deliveryRateCurrency: "",
            exportCustomsRate: "",
            exportCustomsRateCurrency: "",
            importCustomsRate: "",
            importCustomsRateCurrency: "",
            sellingRate: "",
            sellingRateCurrency: "",

            // 21 -> MERSIN, TURKEY + COB tarihi
            establishedPlaceText: "MERSIN, TURKEY",
            establishedDate: actualDeparture || null,

            // 22 -> FILENDERS LOGISTICS AND TECHNOLOGY
            senderSignatureText: "FILENDERS LOGISTICS AND TECHNOLOGY",

            // 23 -> boş
            carrierSignatureText: "",

            // 24 -> boş
            goodsReceivedPlaceText: "",
            goodsReceivedDate: null,
            consigneeSignatureText: "",

            totals: {
                totalGrossWeight: computed?.totals?.grossWeight || 0,
                totalUnit: computed?.totals?.unit || 0,
            },
        };
    };
    const buildCmrPayloadForAmbl = () => {
        const shipmentCount = selectedShipmentsState.length;

        if (isFclOperation()) {
            return buildBaseShipmentPayloadFromAmbl();
        }

        if (isLclOperation() && shipmentCount === 1) {
            return buildBaseShipmentPayloadFromAmbl();
        }

        if (isLclOperation() && shipmentCount > 1) {
            return buildMultiLclCmrPayload();
        }

        return buildBaseShipmentPayloadFromAmbl();
    };


    const dialogPaperSx = {
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
        border: "1px solid rgba(25,118,210,0.12)",
    };

    const selectionCardSx = (active) => ({
        borderRadius: "18px",
        p: 2.25,
        cursor: "pointer",
        border: active ? "2px solid #1976d2" : "1px solid #e5e7eb",
        background: active
            ? "linear-gradient(135deg, rgba(25,118,210,0.10), rgba(25,118,210,0.03))"
            : "#fff",
        boxShadow: active
            ? "0 12px 30px rgba(25,118,210,0.18)"
            : "0 6px 18px rgba(15,23,42,0.06)",
        transition: "all 0.25s ease",
        minHeight: 150,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: active
                ? "0 14px 34px rgba(25,118,210,0.22)"
                : "0 10px 24px rgba(15,23,42,0.10)",
        },
    });

    const getSelectedCarrierName = () => {
        if (typeof selectedLinehaulProvider === "string") return selectedLinehaulProvider;
        if (selectedLinehaulProvider?.name) return selectedLinehaulProvider.name;
        if (selectedLinehaulProvider?.label) return selectedLinehaulProvider.label;
        return "";
    };

    const isExportOperation = () => {
        const first = getFirstShipmentAttr();
        const mode = String(first?.airTransportType || "").toUpperCase();
        return mode.includes("EXPORT");
    };

    const isImportOperation = () => {
        const first = getFirstShipmentAttr();
        const mode = String(first?.airTransportType || "").toUpperCase();
        return mode.includes("IMPORT");
    };

    const buildMergedCargoDetailsForPdf = () => {
        return (selectedShipmentsState || []).flatMap((shipment) => {
            const cargoList = Array.isArray(shipment?.attributes?.cargoDetails)
                ? shipment.attributes.cargoDetails
                : [];

            return cargoList.map((cargo) => ({
                containers: cargo?.containers || [],
                unitQuantity: cargo?.unitQuantity || "",
                selectedPackingType: cargo?.selectedPackingType || "",
                commodity: cargo?.commodity || cargo?.description || "",
                grossWeight: cargo?.grossWeight || "",
                cbm: cargo?.cbm || "",
            }));
        });
    };
    const handleOpenPrintDialog = async () => {
        try {
            setSaving(true);

            await saveAmblToBackendOnce();

            setPrintDialogOpen(true);
        } catch (err) {
            console.error("BILL OF LADING save error:", err);
            appAlert("AMBL could not be saved before printing.");
        } finally {
            setSaving(false);
        }
    };
    const handleClosePrintDialog = () => {setPrintDialogOpen(false);};

    const buildDocumentFieldData = () => {
        const first = getFirstShipmentAttr();

        const pickup1 = first?.pickupAddress1 || {};
        const pickup2 = first?.pickupAddress2 || {};
        const delivery1 = first?.deliveryAddress1 || {};
        const delivery2 = first?.deliveryAddress2 || {};

        const carrierName = getSelectedCarrierName();
        const isExport = isExportOperation();
        const isImport = isImportOperation();

        let consignor = "";
        let consignee = "";
        let notify = "";

        if (isExport) {
            consignor = "FILENDERS";
            consignee = carrierName;
            notify = carrierName;
        } else if (isImport) {
            consignor = carrierName;
            consignee = "FILENDERS";
            notify = "FILENDERS";
        } else {
            consignor = carrierName || "FILENDERS";
            consignee = carrierName || "FILENDERS";
            notify = carrierName || "FILENDERS";
        }

        const pol =
            pickup2?.port ||
            pickup1?.port ||
            "";

        const pod =
            delivery1?.port ||
            delivery2?.port ||
            "";

        const placeOfReceipt = [
            pickup1?.city || pickup2?.city || "",
            pickup1?.country || pickup2?.country || "",
        ]
            .filter(Boolean)
            .join(", ");

        const placeOfDelivery = [
            delivery2?.city || delivery1?.city || "",
            delivery2?.country || delivery1?.country || "",
        ]
            .filter(Boolean)
            .join(", ");
        if (finalMblShipper) consignor = finalMblShipper;
        if (finalMblConsignee) consignee = finalMblConsignee;
        if (finalMblNotify) notify = finalMblNotify;
        return {
            consignor,
            consignee,
            notify,
            pol,
            pod,
            placeOfReceipt,
            placeOfDelivery,
            vesselName: vesselName || getVesselName(first) || "",
            topRightNumber: documentTopRightNumber || "",
        };
    };

    const normalizePdfText = (value = "") => {
        const map = {
            ç: "c", ğ: "g", ı: "i", ö: "o", ş: "s", ü: "u",
            Ç: "C", Ğ: "G", İ: "I", Ö: "O", Ş: "S", Ü: "U",
        };

        return String(value)
            .split("")
            .map((char) => map[char] || char)
            .join("")
            .toUpperCase();
    };

    const drawTextSafe = (page, text, x, y, options = {}) => {
        if (text === null || text === undefined || text === "") return;

        page.drawText(normalizePdfText(text), {
            x,
            y,
            size: options.size || 8,
            font: options.font,
            color: options.color,
            maxWidth: options.maxWidth,
            lineHeight: options.lineHeight || 9,
        });
    };

    const getPdfLayoutByType = (printType) => {
        if (printType === "seawaybill") {
            return {
                topRightNumber: {
                    rect: {
                        x: 487,
                        y: 773,
                        width: 78,
                        height: 13,
                        color: rgb(1, 1, 1),
                    },
                    text: {
                        x: 495,
                        y: 775,
                        size: 12,
                        maxWidth: 55,
                        color: rgb(1, 0, 0),
                    },
                },

                consignor: { x: 70, y: 778, size: 9, maxWidth: 220, lineHeight: 10 },
                consignee: { x: 70, y: 708, size: 9, maxWidth: 220, lineHeight: 10 },
                notify: { x: 70, y: 633, size: 9, maxWidth: 220, lineHeight: 10 },

                placeOfReceipt: { x: 195, y: 585, size: 7, maxWidth: 110, lineHeight: 9 },
                pol: { x: 195, y: 558, size: 7, maxWidth: 95, lineHeight: 9 },
                pod: { x: 65, y: 535, size: 7, maxWidth: 95, lineHeight: 9 },
                placeOfDelivery: { x: 195, y: 535, size: 7, maxWidth: 110, lineHeight: 9 },
                vesselName: {x: 65, y: 558, size: 7, maxWidth: 95, lineHeight: 9 },

                cargo: {
                    startY: printType === "seawaybill" ? 490 : 495,
                    rowHeight: 18,
                    xOffset: 50,
                    minY: 120,
                    marksAndNumbers: { x: 5, size: 9, maxWidth: 70, lineHeight: 10 },
                    packages: { x: 130, size: 9, maxWidth: 110, lineHeight: 10 },
                    description: { x: 275, size: 9, maxWidth: 170, lineHeight: 10 },
                    grossWeight: { x: 425, size: 9, maxWidth: 55, lineHeight: 10 },
                    measurement: { x: 480, size: 9, maxWidth: 55, lineHeight: 10 },
                },
            };
        }

        return {
            topRightNumber: {
                rect: {
                    x: 487,
                    y: 773,
                    width: 78,
                    height: 13,
                    color: rgb(1, 1, 1),
                },
                text: {
                    x: 495,
                    y: 775,
                    size: 12,
                    maxWidth: 55,
                    color: rgb(1, 0, 0),
                },
            },

            consignor: { x: 70, y: 778, size: 9, maxWidth: 220, lineHeight: 10 },
            consignee: { x: 70, y: 708, size: 9, maxWidth: 220, lineHeight: 10 },
            notify: { x: 70, y: 633, size: 9, maxWidth: 220, lineHeight: 10 },

            placeOfReceipt: { x: 195, y: 585, size: 7, maxWidth: 110, lineHeight: 9 },
            pol: { x: 195, y: 558, size: 7, maxWidth: 95, lineHeight: 9 },
            pod: { x: 65, y: 535, size: 7, maxWidth: 95, lineHeight: 9 },
            placeOfDelivery: { x: 195, y: 535, size: 7, maxWidth: 110, lineHeight: 9 },
            vesselName: {x: 65, y: 558, size: 7, maxWidth: 95, lineHeight: 9 },

            cargo: {
                startY: printType === "original" ? 490 : 495,
                rowHeight: 18,
                xOffset: 50,
                minY: 120,
                marksAndNumbers: { x: 5, size: 9, maxWidth: 70, lineHeight: 10 },
                packages: { x: 130, size: 9, maxWidth: 110, lineHeight: 10 },
                description: { x: 275, size: 9, maxWidth: 170, lineHeight: 10 },
                grossWeight: { x: 425, size: 9, maxWidth: 55, lineHeight: 10 },
                measurement: { x: 480, size: 9, maxWidth: 55, lineHeight: 10 },
            },
        };
    };
    const drawField = (page, text, layoutField, font) => {
        if (!layoutField) return;

        drawTextSafe(page, text, layoutField.x, layoutField.y, {
            font,
            size: layoutField.size,
            maxWidth: layoutField.maxWidth,
            lineHeight: layoutField.lineHeight,
            color: layoutField.color,
        });
    };

    const createFilledFrontPdf = async (frontPdfUrl) => {
        const fieldData = buildDocumentFieldData();
        const mergedCargoDetails = buildMergedCargoDetailsForPdf();

        const response = await fetch(frontPdfUrl);
        if (!response.ok) {
            throw new Error(`PDF alınamadı: ${frontPdfUrl}`);
        }

        const arrayBuffer = await response.arrayBuffer();
        const pdfDoc = await PDFDocument.load(arrayBuffer);

        const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
        const page = pdfDoc.getPage(0);
        const layout = getPdfLayoutByType(selectedPrintType);

        page.drawRectangle({
            x: layout.topRightNumber.rect.x,
            y: layout.topRightNumber.rect.y,
            width: layout.topRightNumber.rect.width,
            height: layout.topRightNumber.rect.height,
            color: layout.topRightNumber.rect.color,
            borderWidth: 0,
        });

        drawTextSafe(
            page,
            fieldData.topRightNumber,
            layout.topRightNumber.text.x,
            layout.topRightNumber.text.y,
            {
                font,
                size: layout.topRightNumber.text.size,
                maxWidth: layout.topRightNumber.text.maxWidth,
                lineHeight: 10,
                color: layout.topRightNumber.text.color,
            }
        );

        drawField(page, fieldData.consignor, layout.consignor, font);
        drawField(page, fieldData.consignee, layout.consignee, font);
        drawField(page, fieldData.notify, layout.notify, font);

        drawField(page, fieldData.placeOfReceipt, layout.placeOfReceipt, font);
        drawField(page, fieldData.pol, layout.pol, font);
        drawField(page, fieldData.pod, layout.pod, font);
        drawField(page, fieldData.placeOfDelivery, layout.placeOfDelivery, font);
        drawField(page, fieldData.vesselName, layout.vesselName, font);

        // Tüm shipment cargo satırları
        const cargoStartY = 430;
        const cargoRowHeight = 18;
        const cargoXOffset = 50;

        mergedCargoDetails.forEach((cargo, index) => {
            const y = layout.cargo.startY - index * layout.cargo.rowHeight;
            if (y < layout.cargo.minY) return;

            const containerText = (cargo.containers || [])
                .map((container) =>
                    [
                        container.containerNo,
                        container.sealNumber,
                        container.containerType,
                    ]
                        .filter(Boolean)
                        .join("\n")
                )
                .join("\n\n");

            drawTextSafe(page, containerText, layout.cargo.marksAndNumbers.x + layout.cargo.xOffset, y, {
                font,
                size: layout.cargo.marksAndNumbers.size,
                maxWidth: layout.cargo.marksAndNumbers.maxWidth,
                lineHeight: layout.cargo.marksAndNumbers.lineHeight,
                color: rgb(0, 0, 0),
            });

            drawTextSafe(
                page,
                `${cargo.unitQuantity || ""} ${cargo.selectedPackingType || ""}`,
                layout.cargo.packages.x + layout.cargo.xOffset,
                y,
                {
                    font,
                    size: layout.cargo.packages.size,
                    maxWidth: layout.cargo.packages.maxWidth,
                    lineHeight: layout.cargo.packages.lineHeight,
                    color: rgb(0, 0, 0),
                }
            );

            drawTextSafe(page, cargo.commodity || "", layout.cargo.description.x + layout.cargo.xOffset, y, {
                font,
                size: layout.cargo.description.size,
                maxWidth: layout.cargo.description.maxWidth,
                lineHeight: layout.cargo.description.lineHeight,
                color: rgb(0, 0, 0),
            });

            drawTextSafe(page, String(cargo.grossWeight || ""), layout.cargo.grossWeight.x + layout.cargo.xOffset, y, {
                font,
                size: layout.cargo.grossWeight.size,
                maxWidth: layout.cargo.grossWeight.maxWidth,
                lineHeight: layout.cargo.grossWeight.lineHeight,
                color: rgb(0, 0, 0),
            });

            drawTextSafe(page, cargo.cbm ? `${cargo.cbm} CBM` : "", layout.cargo.measurement.x + layout.cargo.xOffset, y, {
                font,
                size: layout.cargo.measurement.size,
                maxWidth: layout.cargo.measurement.maxWidth,
                lineHeight: layout.cargo.measurement.lineHeight,
                color: rgb(0, 0, 0),
            });
        });
        return await pdfDoc.save();
    };

    const handleGoInvoice = async () => {
        try {
            setSaving(true);

            const payload = buildInvoicePayloadFromAmbl();

            if (!payload) {
                appAlert("This AMBL has no linked shipments. Invoice cannot be created.");
                return;
            }

            await saveAmblToBackendOnce();

            setInvoiceState({
                shipments: payload.formattedShipments,
                linehaulServiceProviderMap: payload.linehaulServiceProviderMap,
                fromMbl: true,
                ambl: {
                    amblNumber,
                    finalMblShipper,
                    finalMblConsignee,
                    finalMblNotify,
                    financialSummary,
                    freightCharges: {
                        totalCurrency,
                    },
                },
                sourceType: "air",
            });

            setInvoiceDialogOpen(true);
        } catch (err) {
            console.error("Invoice open error:", err);
            appAlert("Invoice could not be opened. Please try again.");
        } finally {
            setSaving(false);
        }
    };


    const content = (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
            <MDBox
                pt={4}
                pb={3}
                sx={{
                    background:
                        "radial-gradient(circle at top left, rgba(14,165,233,0.10), transparent 32%), radial-gradient(circle at top right, rgba(34,197,94,0.10), transparent 30%)",
                }}
            >
                <Card
                    sx={{
                        mb: 3,
                        p: { xs: 2.25, md: 3 },
                        borderRadius: "24px",
                        border: "1px solid rgba(148,163,184,0.22)",
                        background:
                            "linear-gradient(135deg, rgba(15,23,42,0.96), rgba(30,64,175,0.92))",
                        boxShadow: "0 22px 55px rgba(15,23,42,0.22)",
                        overflow: "hidden",
                        position: "relative",
                        "&:before": {
                            content: '""',
                            position: "absolute",
                            width: 260,
                            height: 260,
                            borderRadius: "50%",
                            right: -90,
                            top: -120,
                            background: "rgba(14,165,233,0.22)",
                        },
                        "&:after": {
                            content: '""',
                            position: "absolute",
                            width: 180,
                            height: 180,
                            borderRadius: "50%",
                            right: 130,
                            bottom: -110,
                            background: "rgba(34,197,94,0.16)",
                        },
                    }}
                >
                    <MDBox
                        position="relative"
                        zIndex={1}
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={2}
                    >
                        <MDBox>
                            <MDBox display="flex" gap={1} flexWrap="wrap" mb={1.25}>
                                <Chip
                                    size="small"
                                    label="Air MBL"
                                    sx={{
                                        color: "#fff",
                                        fontWeight: "bold",
                                        backgroundColor: "rgba(255,255,255,0.16)",
                                        border: "1px solid rgba(255,255,255,0.18)",
                                    }}
                                />
                                <Chip
                                    size="small"
                                    label={isEditMode ? "Edit Mode" : "Create Mode"}
                                    color={isEditMode ? "warning" : "success"}
                                    sx={{ fontWeight: "bold" }}
                                />
                                {hasData ? (
                                    <Chip
                                        size="small"
                                        label={`${selectedShipmentsState.length} linked shipment${selectedShipmentsState.length > 1 ? "s" : ""}`}
                                        sx={{
                                            color: "#e0f2fe",
                                            fontWeight: "bold",
                                            backgroundColor: "rgba(14,165,233,0.18)",
                                        }}
                                    />
                                ) : null}
                            </MDBox>

                            <MDTypography variant="h3" fontWeight="bold" color="white" sx={{ lineHeight: 1.1 }}>
                                {isEditMode ? `EDIT - ${amblNumber || ""}` : "Air MBL Workspace"}
                            </MDTypography>
                            <MDTypography variant="button" color="white" sx={{ opacity: 0.82, display: "block", mt: 0.75 }}>
                                Manage AMBL parties, document generation, air freight costs, shipment history and consolidation flow.
                            </MDTypography>
                        </MDBox>

                        <MDBox
                            display="flex"
                            gap={1}
                            flexWrap="wrap"
                            justifyContent={{ xs: "flex-start", md: "flex-end" }}
                        >
                            <MDButton
                                variant="outlined"
                                color="white"
                                onClick={() => navigate(-1)}
                                sx={{
                                    borderColor: "rgba(255,255,255,0.45)",
                                    color: "#fff",
                                    "&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.08)" },
                                }}
                            >
                                Back
                            </MDButton>

                            <MDButton
                                variant="contained"
                                color="light"
                                onClick={handleOpenPrintDialog}
                                disabled={saving || !hasData}
                                startIcon={<DescriptionOutlinedIcon />}
                            >
                                {saving ? "Saving..." : "Print BILL OF LADING"}
                            </MDButton>


                            <MDButton
                                variant="contained"
                                color="info"
                                onClick={handleGoInvoice}
                                disabled={saving || !hasData}
                                startIcon={<ReceiptLongOutlinedIcon />}
                            >
                                {saving ? "Saving..." : "Save & Invoice Details"}
                            </MDButton>

                            <MDButton
                                variant="contained"
                                color="success"
                                onClick={handleGoToConsolidation}
                                disabled={saving || !hasData}
                                startIcon={<SaveOutlinedIcon />}
                            >
                                {saving
                                    ? "Saving..."
                                    : isEditMode
                                        ? "Update & Go to Consolidation"
                                        : "Save & Go to Consolidation"}
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </Card>

                {hasData ? (
                    <KpiStrip sx={{ mb: 3 }}>
                        <FinanceKpi label={embedded ? "DBL No" : "AMBL No"} value={amblNumber || "-"} hint={isEditMode ? "Saved record" : "New record"} />
                        <FinanceKpi
                            label="Linked Shipments"
                            value={selectedShipmentsState.length}
                            hint={selectedShipmentsState.length === 1 ? "House file" : "House files"}
                        />
                        <FinanceKpi
                            label="Total Gross Weight"
                            value={`${formatQuantity(computed.totals.grossWeight)} kg`}
                            hint={`${formatQuantity(computed.totals.unit, 0)} packages`}
                        />
                        <FinanceKpi
                            label="Total Selling"
                            value={formatMoney(financialSummary.totalSellingRate, totalCurrency)}
                            hint={`Cost ${formatMoney(financialSummary.buyingRate, totalCurrency)}`}
                        />
                        <FinanceKpi
                            label="Gross Profit"
                            value={formatMoney(financialSummary.totalProfit, totalCurrency)}
                            toneKey={profitTone(financialSummary.totalProfit)}
                            hint={`${profitLabel(financialSummary.totalProfit)} · ${formatPercent(profitMargin)} margin`}
                        />
                    </KpiStrip>
                ) : null}
                {hasData && (
                    <SectionCard
                        title="MBL Party Configuration"
                        subtitle="Select how MBL shipper and consignee will be determined from AHFL, Filenders or Global Agent records."
                    >
                        <MDBox
                            sx={{
                                p: 2,
                                mb: 2,
                                borderRadius: "14px",
                                background: "linear-gradient(135deg, #f8fafc, #eef2ff)",
                                border: "1px solid #e2e8f0",
                            }}
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        select
                                        label="Booking Responsible Party"
                                        value={bookingResponsibleParty}
                                        onChange={(e) => {
                                            setBookingResponsibleParty(e.target.value);
                                            setSelectedBookingAgent(null);
                                        }}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        <MenuItem value="GLOBAL_AGENT">Global Agent</MenuItem>
                                        <MenuItem value="FILENDERS">Filenders</MenuItem>
                                    </TextField>
                                </Grid>

                                {bookingResponsibleParty === "GLOBAL_AGENT" && (
                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            options={serviceProviders}
                                            value={selectedBookingAgent}
                                            onChange={(_e, newValue) => setSelectedBookingAgent(newValue)}
                                            getOptionLabel={(option) => getAgentName(option)}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Booking Global Agent"
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                )}

                                <Grid item xs={12} md={3}>
                                    <TextField
                                        select
                                        label="Freight Status"
                                        value={freightStatus}
                                        onChange={(e) => setFreightStatus(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        <MenuItem value="Prepaid">Prepaid</MenuItem>
                                        <MenuItem value="Collect">Collect</MenuItem>
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Card
                                        sx={{
                                            p: 1.5,
                                            borderRadius: "12px",
                                            height: "100%",
                                            boxShadow: "none",
                                            border: "1px solid #cbd5e1",
                                            backgroundColor: "#fff",
                                        }}
                                    >
                                        <MDTypography variant="caption" color="text">
                                            Route
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" display="block">
                                            AOL: {polCountry || "-"}
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" display="block">
                                            AOD: {podCountry || "-"}
                                        </MDTypography>
                                    </Card>
                                </Grid>
                            </Grid>
                        </MDBox>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <Card
                                    sx={{
                                        p: 2,
                                        borderRadius: "16px",
                                        border: "1px solid #dbeafe",
                                        backgroundColor: "#ffffff",
                                        boxShadow: "0 8px 24px rgba(37,99,235,0.08)",
                                        height: "100%",
                                    }}
                                >
                                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                        <MDBox>
                                            <MDTypography variant="h6" fontWeight="bold" color="info">
                                                Origin / MBL Shipper
                                            </MDTypography>
                                            <MDTypography variant="caption" color="text">
                                                AOL country: {polCountry || "Not selected"}
                                            </MDTypography>
                                        </MDBox>

                                        <Chip
                                            size="small"
                                            color={finalMblShipper ? "success" : "default"}
                                            label={finalMblShipper ? "Ready" : "Pending"}
                                            sx={{ fontWeight: "bold" }}
                                        />
                                    </MDBox>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={5}>
                                            <TextField
                                                select
                                                label="Use Origin Agent?"
                                                value={originAgentEnabled}
                                                onChange={(e) => {
                                                    setOriginAgentEnabled(e.target.value);
                                                    setSelectedOriginAgent(null);
                                                    setOriginActualType("");
                                                }}
                                                fullWidth
                                                size="small"
                                                sx={FIELD_SX}
                                                InputLabelProps={{ shrink: true }}
                                            >
                                                <MenuItem value="YES">Yes - Use Global Agent</MenuItem>
                                                <MenuItem value="NO">No - Use Filenders / Actual Shipper</MenuItem>
                                            </TextField>
                                        </Grid>

                                        {originAgentEnabled === "YES" && (
                                            <Grid item xs={12} md={7}>
                                                <Autocomplete
                                                    options={originAgentOptions}
                                                    value={selectedOriginAgent}
                                                    onChange={(_e, newValue) => setSelectedOriginAgent(newValue)}
                                                    getOptionLabel={(option) => getAgentName(option)}
                                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                    noOptionsText={
                                                        polCountry
                                                            ? `No Global Agent found for AOL country: ${polCountry}`
                                                            : "AOL country not found"
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label={`Global Agent for ${polCountry || "AOL"}`}
                                                            fullWidth
                                                            size="small"
                                                            sx={FIELD_SX}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        )}

                                        {originAgentEnabled === "NO" && (
                                            <Grid item xs={12} md={7}>
                                                <TextField
                                                    select
                                                    label="MBL Shipper Source"
                                                    value={originActualType}
                                                    onChange={(e) => setOriginActualType(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                >
                                                    <MenuItem value="FILENDERS">Filenders</MenuItem>
                                                    <MenuItem value="ACTUAL">Actual Shipper from AHFL</MenuItem>
                                                </TextField>
                                            </Grid>
                                        )}
                                    </Grid>

                                    <MDBox
                                        mt={2}
                                        p={2}
                                        sx={{
                                            borderRadius: "12px",
                                            backgroundColor: "#eff6ff",
                                            border: "1px dashed #93c5fd",
                                        }}
                                    >
                                        <MDTypography variant="caption" color="text">
                                            Final MBL Shipper
                                        </MDTypography>
                                        <MDTypography variant="h6" fontWeight="bold" color="info">
                                            {finalMblShipper || "-"}
                                        </MDTypography>

                                        {originActualType === "ACTUAL" && (
                                            <MDTypography variant="caption" color="text">
                                                Actual AHFL Shipper: {getActualShipper() || "-"}
                                            </MDTypography>
                                        )}
                                    </MDBox>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card
                                    sx={{
                                        p: 2,
                                        borderRadius: "16px",
                                        border: "1px solid #dcfce7",
                                        backgroundColor: "#ffffff",
                                        boxShadow: "0 8px 24px rgba(22,163,74,0.08)",
                                        height: "100%",
                                    }}
                                >
                                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                        <MDBox>
                                            <MDTypography variant="h6" fontWeight="bold" color="success">
                                                Destination / MBL Consignee
                                            </MDTypography>
                                            <MDTypography variant="caption" color="text">
                                                AOD country: {podCountry || "Not selected"}
                                            </MDTypography>
                                        </MDBox>

                                        <Chip
                                            size="small"
                                            color={finalMblConsignee ? "success" : "default"}
                                            label={finalMblConsignee ? "Ready" : "Pending"}
                                            sx={{ fontWeight: "bold" }}
                                        />
                                    </MDBox>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={5}>
                                            <TextField
                                                select
                                                label="Use Destination Agent?"
                                                value={destinationAgentEnabled}
                                                onChange={(e) => {
                                                    setDestinationAgentEnabled(e.target.value);
                                                    setSelectedDestinationAgent(null);
                                                    setDestinationActualType("");
                                                }}
                                                fullWidth
                                                size="small"
                                                sx={FIELD_SX}
                                                InputLabelProps={{ shrink: true }}
                                            >
                                                <MenuItem value="YES">Yes - Use Global Agent</MenuItem>
                                                <MenuItem value="NO">No - Use Filenders / Actual Consignee</MenuItem>
                                            </TextField>
                                        </Grid>

                                        {destinationAgentEnabled === "YES" && (
                                            <Grid item xs={12} md={7}>
                                                <Autocomplete
                                                    options={destinationAgentOptions}
                                                    value={selectedDestinationAgent}
                                                    onChange={(_e, newValue) => setSelectedDestinationAgent(newValue)}
                                                    getOptionLabel={(option) => getAgentName(option)}
                                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                    noOptionsText={
                                                        podCountry
                                                            ? `No Global Agent found for AOD country: ${podCountry}`
                                                            : "AOD country not found"
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label={`Global Agent for ${podCountry || "AOD"}`}
                                                            fullWidth
                                                            size="small"
                                                            sx={FIELD_SX}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        )}

                                        {destinationAgentEnabled === "NO" && (
                                            <Grid item xs={12} md={7}>
                                                <TextField
                                                    select
                                                    label="MBL Consignee Source"
                                                    value={destinationActualType}
                                                    onChange={(e) => setDestinationActualType(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                >
                                                    <MenuItem value="FILENDERS">Filenders</MenuItem>
                                                    <MenuItem value="ACTUAL">Actual Consignee from AHFL</MenuItem>
                                                </TextField>
                                            </Grid>
                                        )}
                                    </Grid>

                                    <MDBox
                                        mt={2}
                                        p={2}
                                        sx={{
                                            borderRadius: "12px",
                                            backgroundColor: "#f0fdf4",
                                            border: "1px dashed #86efac",
                                        }}
                                    >
                                        <MDTypography variant="caption" color="text">
                                            Final MBL Consignee
                                        </MDTypography>
                                        <MDTypography variant="h6" fontWeight="bold" color="success">
                                            {finalMblConsignee || "-"}
                                        </MDTypography>

                                        {destinationActualType === "ACTUAL" && (
                                            <MDTypography variant="caption" color="text">
                                                Actual AHFL Consignee: {getActualConsignee() || "-"}
                                            </MDTypography>
                                        )}
                                    </MDBox>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Card
                                    sx={{
                                        p: 2,
                                        borderRadius: "16px",
                                        border: "1px solid #fef3c7",
                                        backgroundColor: "#ffffff",
                                        boxShadow: "0 8px 24px rgba(245,158,11,0.08)",
                                        height: "100%",
                                    }}
                                >
                                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                        <MDBox>
                                            <MDTypography variant="h6" fontWeight="bold" color="warning">
                                                Notify Party
                                            </MDTypography>
                                            <MDTypography variant="caption" color="text">
                                                AOD country: {podCountry || "Not selected"}
                                            </MDTypography>
                                        </MDBox>

                                        <Chip
                                            size="small"
                                            color={finalMblNotify ? "success" : "default"}
                                            label={finalMblNotify ? "Ready" : "Pending"}
                                            sx={{ fontWeight: "bold" }}
                                        />
                                    </MDBox>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={5}>
                                            <TextField
                                                select
                                                label="Use Notify Agent?"
                                                value={notifyAgentEnabled}
                                                onChange={(e) => {
                                                    setNotifyAgentEnabled(e.target.value);
                                                    setSelectedNotifyAgent(null);
                                                    setNotifyActualType("");
                                                }}
                                                fullWidth
                                                size="small"
                                                sx={FIELD_SX}
                                                InputLabelProps={{ shrink: true }}
                                            >
                                                <MenuItem value="YES">Yes - Use Global Agent</MenuItem>
                                                <MenuItem value="NO">No - Use Filenders / Actual Notify</MenuItem>
                                            </TextField>
                                        </Grid>

                                        {notifyAgentEnabled === "YES" && (
                                            <Grid item xs={12} md={7}>
                                                <Autocomplete
                                                    options={notifyAgentOptions}
                                                    value={selectedNotifyAgent}
                                                    onChange={(_e, newValue) => setSelectedNotifyAgent(newValue)}
                                                    getOptionLabel={(option) => getAgentName(option)}
                                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label={`Global Agent for ${podCountry || "POD"}`}
                                                            fullWidth
                                                            size="small"
                                                            sx={FIELD_SX}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        )}

                                        {notifyAgentEnabled === "NO" && (
                                            <Grid item xs={12} md={7}>
                                                <TextField
                                                    select
                                                    label="MBL Notify Source"
                                                    value={notifyActualType}
                                                    onChange={(e) => setNotifyActualType(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                >
                                                    <MenuItem value="FILENDERS">Filenders</MenuItem>
                                                    <MenuItem value="ACTUAL">Actual Notify from AHFL</MenuItem>
                                                    <MenuItem value="SAME_AS_CONSIGNEE">Same as Final MBL Consignee</MenuItem>
                                                </TextField>
                                            </Grid>
                                        )}
                                    </Grid>

                                    <MDBox
                                        mt={2}
                                        p={2}
                                        sx={{
                                            borderRadius: "12px",
                                            backgroundColor: "#fffbeb",
                                            border: "1px dashed #facc15",
                                        }}
                                    >
                                        <MDTypography variant="caption" color="text">
                                            Final MBL Notify
                                        </MDTypography>
                                        <MDTypography variant="h6" fontWeight="bold" color="warning">
                                            {finalMblNotify || "-"}
                                        </MDTypography>

                                        {notifyActualType === "ACTUAL" && (
                                            <MDTypography variant="caption" color="text">
                                                Actual AHFL Notify: {getActualNotify() || "-"}
                                            </MDTypography>
                                        )}
                                    </MDBox>
                                </Card>
                            </Grid>
                        </Grid>
                    </SectionCard>
                )}
                {!hasData ? (
                    <Card
                        sx={{
                            p: 3,
                            borderRadius: "14px",
                            border: "1px solid #eee",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                        }}
                    >
                        <Alert severity="warning">
                            No selected shipments found. Please go back and select AHFL shipments first.
                        </Alert>
                    </Card>
                ) : (
                    <>
                        <SectionCard
                            title="AMBL Details"
                            subtitle="Auto-filled HFL schedule and reference details for linked shipments.">
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={5}>
                                    <Card
                                        sx={{
                                            p: 2.25,
                                            borderRadius: "18px",
                                            border: "1px solid rgba(37,99,235,0.16)",
                                            background: "linear-gradient(145deg, #ffffff, #f8fafc)",
                                            boxShadow: "0 12px 32px rgba(15,23,42,0.06)",
                                            height: "100%",
                                        }}
                                    >
                                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                            <MDBox>
                                                <MDTypography variant="h6" fontWeight="bold">
                                                    Reference Information
                                                </MDTypography>
                                                <MDTypography variant="caption" color="text">
                                                    Linked HFL shipment references
                                                </MDTypography>
                                            </MDBox>

                                            <Chip
                                                size="small"
                                                color="info"
                                                label={`${selectedShipmentsState.length} HFL`}
                                                sx={{ fontWeight: "bold" }}
                                            />
                                        </MDBox>

                                        <Grid container spacing={1.5}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    label="AMBL Number"
                                                    value={amblNumber || ""}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{
                                                        readOnly: true,
                                                        onClick: handleGoAmblForm,
                                                        style: { cursor: isEditMode ? "pointer" : "default" },
                                                    }}
                                                />
                                            </Grid>

                                            {getHflReferenceRows().map((row) => (
                                                <Grid item xs={12} key={row.id}>
                                                    <Card
                                                        sx={{
                                                            p: 1.75,
                                                            borderRadius: "14px",
                                                            border: "1px solid #e2e8f0",
                                                            backgroundColor: "#fff",
                                                            boxShadow: "0 8px 20px rgba(15,23,42,0.04)",
                                                        }}
                                                    >
                                                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                                            <MDTypography
                                                                variant="button"
                                                                fontWeight="bold"
                                                                color="info"
                                                                sx={linkTextSx}
                                                                onClick={() => handleGoShipmentForm(row.id)}
                                                            >
                                                                {row.hNumber}
                                                            </MDTypography>

                                                            <Chip
                                                                size="small"
                                                                label={row.containerType}
                                                                color="default"
                                                                sx={{ fontWeight: "bold" }}
                                                            />
                                                        </MDBox>

                                                        <Grid container spacing={1}>
                                                            <Grid item xs={12} sm={6}>
                                                                <MDTypography variant="caption" color="text">
                                                                    Booking Number
                                                                </MDTypography>
                                                                <MDTypography variant="button" fontWeight="bold" display="block">
                                                                    {row.bookingNumber}
                                                                </MDTypography>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <MDTypography variant="caption" color="text">
                                                                    Container Number
                                                                </MDTypography>
                                                                <MDTypography variant="button" fontWeight="bold" display="block">
                                                                    {row.containerNumber}
                                                                </MDTypography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6}>
                                                                <MDTypography variant="caption" color="text">
                                                                    SB Number
                                                                </MDTypography>
                                                                <MDTypography variant="button" fontWeight="bold" display="block">
                                                                    {row.sealNumber}
                                                                </MDTypography>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <MDTypography variant="caption" color="text">
                                                                    Vessel
                                                                </MDTypography>
                                                                <MDTypography variant="button" fontWeight="bold" display="block">
                                                                    {row.vesselName}
                                                                </MDTypography>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                <MDTypography variant="caption" color="text">
                                                                    ETA / Cut-off
                                                                </MDTypography>
                                                                <MDTypography variant="button" fontWeight="bold" display="block">
                                                                    {row.eta ? new Date(row.eta).toLocaleDateString("tr-TR") : "-"} /{" "}
                                                                    {row.cutoff ? new Date(row.cutoff).toLocaleDateString("tr-TR") : "-"}
                                                                </MDTypography>
                                                            </Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={7}>
                                    <Card
                                        sx={{
                                            p: 2.25,
                                            borderRadius: "18px",
                                            border: "1px solid rgba(34,197,94,0.18)",
                                            background: "linear-gradient(145deg, #ffffff, #f8fafc)",
                                            boxShadow: "0 12px 32px rgba(15,23,42,0.06)",
                                            height: "100%",
                                        }}
                                    >
                                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                            <MDBox>
                                                <MDTypography variant="h6" fontWeight="bold">
                                                    Schedule Details
                                                </MDTypography>
                                                <MDTypography variant="caption" color="text">
                                                    COB, ETA, Cut-off and Vessel are auto-filled from HFL and can be updated.
                                                </MDTypography>
                                            </MDBox>

                                            <Chip
                                                size="small"
                                                color={hasEtaDelay ? "warning" : "success"}
                                                label={hasEtaDelay ? "Delay Detected" : "On Schedule"}
                                                sx={{ fontWeight: "bold" }}
                                            />
                                        </MDBox>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <DatePicker
                                                    label="COB"
                                                    value={actualDeparture}
                                                    onChange={setActualDeparture}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            size: "small",
                                                            sx: FIELD_SX,
                                                            InputLabelProps: { shrink: true },
                                                        },
                                                        actionBar: { actions: ["clear", "accept"] },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="COB Time"
                                                    type="time"
                                                    value={actualDepartureTime}
                                                    onChange={(e) => setActualDepartureTime(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ step: 900 }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <DatePicker
                                                    label="AAD"
                                                    value={aadDate}
                                                    onChange={setAadDate}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            size: "small",
                                                            sx: FIELD_SX,
                                                            InputLabelProps: { shrink: true },
                                                        },
                                                        actionBar: { actions: ["clear", "accept"] },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="AAD Time"
                                                    type="time"
                                                    value={aadTime}
                                                    onChange={(e) => setAadTime(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ step: 900 }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <DatePicker
                                                    label="ETA"
                                                    value={estimatedDeliveryDate}
                                                    onChange={handleEtaDateChange}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            size: "small",
                                                            sx: FIELD_SX,
                                                            InputLabelProps: { shrink: true },
                                                        },
                                                        actionBar: { actions: ["clear", "accept"] },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="ETA Time"
                                                    type="time"
                                                    value={estimatedDeliveryTime}
                                                    onChange={(e) => setEstimatedDeliveryTime(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ step: 900 }}
                                                />
                                            </Grid>

                                            {(hasEtaDelay || Boolean(delayReason)) && (
                                                <Grid item xs={12}>
                                                    <TextField
                                                        label="Delay Reason"
                                                        value={delayReason}
                                                        onChange={(e) => setDelayReason(e.target.value)}
                                                        fullWidth
                                                        multiline
                                                        minRows={3}
                                                        size="small"
                                                        sx={FIELD_SX}
                                                        InputLabelProps={{ shrink: true }}
                                                        placeholder="The ETA has been postponed. Please explain the reason for the delay..."
                                                    />
                                                </Grid>
                                            )}

                                            <Grid item xs={12} sm={6}>
                                                <DatePicker
                                                    label="Cut-off"
                                                    value={cutOffDate}
                                                    onChange={handleCutOffDateChange}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            size: "small",
                                                            sx: FIELD_SX,
                                                            InputLabelProps: { shrink: true },
                                                        },
                                                        actionBar: { actions: ["clear", "accept"] },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Cut-off Time"
                                                    type="time"
                                                    value={cutOffTime}
                                                    onChange={(e) => setCutOffTime(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ step: 900 }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <DatePicker
                                                    label="RDL Date"
                                                    value={rdlDate}
                                                    onChange={setRdlDate}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            size: "small",
                                                            sx: FIELD_SX,
                                                            InputLabelProps: { shrink: true },
                                                        },
                                                        actionBar: { actions: ["clear", "accept"] },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="RDL Time"
                                                    type="time"
                                                    value={rdlTime}
                                                    onChange={(e) => setRdlTime(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ step: 900 }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Flight Name"
                                                    value={vesselName}
                                                    onChange={(e) => setVesselName(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Transit Time (days)"
                                                    type="number"
                                                    value={transitTime}
                                                    onChange={(e) => setTransitTime(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    sx={FIELD_SX}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ step: 1, min: 0 }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                        </SectionCard>

                        <SectionCard
                            title="Documents"
                            subtitle="Upload related operational and transport documents."
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <DocumentUploadCard
                                        title="Approved Buying Rate"
                                        files={t1t2}
                                        setFiles={setT1t2}
                                        titleSx={TITLE_SX}
                                        wrapperSx={DROPZONE_WRAPPER_SX}
                                        dzStyle={DZ_STYLE}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <DocumentUploadCard
                                        title="Vendor Invoice (Air Freight)"
                                        files={linehaulCarrier}
                                        setFiles={setLinehaulCarrier}
                                        titleSx={TITLE_SX}
                                        wrapperSx={DROPZONE_WRAPPER_SX}
                                        dzStyle={DZ_STYLE}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <DocumentUploadCard
                                        title="Air Carrier MBL"
                                        files={cmr}
                                        setFiles={setCmr}
                                        titleSx={TITLE_SX}
                                        wrapperSx={DROPZONE_WRAPPER_SX}
                                        dzStyle={DZ_STYLE}
                                    />
                                </Grid>
                            </Grid>
                        </SectionCard>
                        <SectionCard
                            title="Shipper / Consignee / Notify"
                            subtitle="Party details for linked shipments and final MBL party selections."
                        >
                            <DataTable table={partiesTable} canSearch />
                        </SectionCard>

                        <SectionCard
                            title="Cost / Selling Rate"
                            subtitle="Review shipment-based cost and selling distribution."
                            rightAction={
                                <TextField
                                    select
                                    label="Total Currency"
                                    value={totalCurrency}
                                    onChange={(e) => {
                                        totalCurrencyTouchedRef.current = true;
                                        setTotalCurrency(e.target.value);
                                    }}
                                    size="small"
                                    sx={{ minWidth: 160, ...FIELD_SX }}
                                    InputLabelProps={{ shrink: true }}
                                >
                                    {CURRENCY_OPTIONS.map((c) => (
                                        <MenuItem key={c} value={c}>
                                            {c}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            }
                        >
                            <DataTable table={pricingTable} canSearch={false} />
                        </SectionCard>

                        <SectionCard
                            title="Freight Charges"
                            subtitle="P/U and Delivery costs come from linked AHFL files. Enter OTHC, Air Freight , DTHC and Handling manually."
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        label="P/U Cost"
                                        value={`${formatNumber(financialSummary.pickupTotal, 2)} ${totalCurrency}`}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        type="number"
                                        label="OTHC Cost"
                                        value={othcCost}
                                        onChange={(e) => setOthcCost(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        select
                                        label="OTHC Currency"
                                        value={othcCurrency}
                                        onChange={(e) => setOthcCurrency(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        {CURRENCY_OPTIONS.map((c) => (
                                            <MenuItem key={c} value={c}>{c}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        type="number"
                                        label="Air Freight Cost"
                                        value={airFreightCost}
                                        onChange={(e) => setAirFreightCost(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        select
                                        label="Air Freight Currency"
                                        value={airFreightCurrency}
                                        onChange={(e) => setAirFreightCurrency(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        {CURRENCY_OPTIONS.map((c) => (
                                            <MenuItem key={c} value={c}>{c}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        type="number"
                                        label="DTHC Cost"
                                        value={dthcCost}
                                        onChange={(e) => setDthcCost(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        select
                                        label="DTHC Currency"
                                        value={dthcCurrency}
                                        onChange={(e) => setDthcCurrency(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        {CURRENCY_OPTIONS.map((c) => (
                                            <MenuItem key={c} value={c}>{c}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        type="number"
                                        label="Handling Cost"
                                        value={handlingCost}
                                        onChange={(e) => setHandlingCost(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        select
                                        label="Handling Currency"
                                        value={handlingCurrency}
                                        onChange={(e) => setHandlingCurrency(e.target.value)}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        {CURRENCY_OPTIONS.map((c) => (
                                            <MenuItem key={c} value={c}>{c}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        label="Delivery Cost"
                                        value={`${formatNumber(financialSummary.deliveryTotal, 2)} ${totalCurrency}`}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={2.4}>
                                    <TextField
                                        label="Buying Rate"
                                        value={`${formatNumber(financialSummary.buyingRate, 2)} ${totalCurrency}`}
                                        fullWidth
                                        size="small"
                                        sx={FIELD_SX}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                            </Grid>
                        </SectionCard>

                        <SectionCard
                            title="Financial Summary"
                            subtitle="Freight charges, selling rate and final profitability snapshot."
                        >
                            <FinancialSummaryPanel
                                costLines={[
                                    { label: "Pick-up", value: financialSummary.pickupTotal },
                                    { label: "OTHC", value: financialSummary.othcTotal },
                                    { label: "Air Freight", value: financialSummary.airFreightTotal },
                                    { label: "DTHC", value: financialSummary.dthcTotal },
                                    { label: "Handling", value: financialSummary.handlingTotal },
                                    { label: "Delivery", value: financialSummary.deliveryTotal },
                                ]}
                                cost={financialSummary.buyingRate}
                                selling={financialSummary.totalSellingRate}
                                profit={financialSummary.totalProfit}
                                margin={profitMargin}
                                currency={totalCurrency}
                            />
                        </SectionCard>

                        <SectionCard
                            title="Shipment History Details"
                            subtitle="Track and update shipment location history."
                            rightAction={
                                <MDBox display="flex" gap={1}>
                                    <MDButton
                                        variant="outlined"
                                        color="info"
                                        onClick={() => setDeliveryPickerOpen(true)}
                                    >
                                        Add Delivery Point
                                    </MDButton>

                                    <MDButton
                                        variant="contained"
                                        color="warning"
                                        onClick={() => setPickupPickerOpen(true)}
                                    >
                                        Add Location History
                                    </MDButton>
                                </MDBox>
                            }
                        >
                            <LocationHistory
                                amblNumber={amblNumber}
                                amblId={amblIdFromUrl}
                                onGoAmbl={handleGoAmblForm}
                                onGoShipment={handleGoShipmentForm}
                                selectedShipmentsState={selectedShipmentsState}
                                locationHistory={locationHistory}
                                setLocationHistory={setLocationHistory}
                                pickupDate={pickupDate}
                                pickupTime={pickupTime}
                                pickupLocation={pickupLocation}
                                proofOfDelivery={proofOfDelivery}
                                proofOfDeliveryTime={proofOfDeliveryTime}
                                deliveryLocation={deliveryLocation}
                                pickupAddress1={pickupAddress1}
                                pickupAddress2={pickupAddress2}
                                deliveryAddress1={deliveryAddress1}
                                deliveryAddress2={deliveryAddress2}
                            />
                        </SectionCard>
                    </>
                )}
            </MDBox>

            <MDBox
                position="sticky"
                bottom={0}
                zIndex={20}
                py={2}
                sx={{
                    backdropFilter: "blur(8px)",
                    background: "rgba(255,255,255,0.85)",
                    borderTop: "1px solid #eee",
                }}
            >
                <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    flexDirection={{ xs: "column", md: "row" }}
                    gap={1.5}
                >
                    <MDBox>
                        <MDTypography variant="button" fontWeight="bold">
                            {isEditMode ? `Editing AMBL: ${amblNumber || "-"}` : "Ready to continue?"}
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                            Save the current AMBL and continue to the consolidation step.
                        </MDTypography>
                    </MDBox>

                    <MDBox display="flex" gap={1}>
                        <MDButton variant="outlined" color="dark" onClick={() => navigate(-1)}>
                            Back
                        </MDButton>


                        <MDButton
                            variant="contained"
                            color="light"
                            onClick={handleOpenPrintDialog}
                            disabled={saving || !hasData}
                            startIcon={<DescriptionOutlinedIcon />}
                        >
                            {saving ? "Saving..." : "Print BILL OF LADING"}
                        </MDButton>


                        <MDButton
                            variant="contained"
                            color="info"
                            onClick={handleGoInvoice}
                            disabled={saving || !hasData}
                            startIcon={<ReceiptLongOutlinedIcon />}
                        >
                            {saving ? "Saving..." : "Save & Invoice Details"}
                        </MDButton>

                        <MDButton
                            variant="contained"
                            color="success"
                            onClick={handleGoToConsolidation}
                            disabled={saving || !hasData}
                            startIcon={<SaveOutlinedIcon />}
                        >
                            {saving
                                ? "Saving..."
                                : isEditMode
                                    ? "Update & Go to Consolidation"
                                    : "Save & Go to Consolidation"}
                        </MDButton>
                    </MDBox>
                </MDBox>
            </MDBox>
        </LocalizationProvider>
    );


    const dialogs = (
        <>
            <Dialog
                open={printDialogOpen}
                onClose={handleClosePrintDialog}
                maxWidth="sm"
                fullWidth
                TransitionComponent={Zoom}
                PaperProps={{ sx: dialogPaperSx }}
            >
                <MDBox
                    sx={{
                        px: 3,
                        py: 2.5,
                        background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                        color: "#fff",
                        position: "relative",
                    }}
                >
                    <MDTypography variant="h5" fontWeight="bold" color="white">
                        Print Shipping Document
                    </MDTypography>
                    <MDTypography variant="button" color="white" sx={{ opacity: 0.9 }}>
                        Choose which document type you want to preview and download
                    </MDTypography>

                    <IconButton
                        onClick={handleClosePrintDialog}
                        sx={{
                            position: "absolute",
                            right: 14,
                            top: 14,
                            color: "#fff",
                            backgroundColor: "rgba(255,255,255,0.10)",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.18)",
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </MDBox>

                <DialogContent sx={{ px: 3, py: 3, backgroundColor: "#f8fafc" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <MDBox
                                sx={selectionCardSx(selectedPrintType === "original")}
                                onClick={() => setSelectedPrintType("original")}
                            >
                                <MDBox display="flex" alignItems="center" gap={1.5}>
                                    <MDBox
                                        sx={{
                                            width: 46,
                                            height: 46,
                                            borderRadius: "12px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "rgba(25,118,210,0.12)",
                                            color: "#1976d2",
                                        }}
                                    >
                                        <DescriptionOutlinedIcon />
                                    </MDBox>

                                    <MDBox>
                                        <MDTypography variant="h6" fontWeight="bold">
                                            Original
                                        </MDTypography>
                                        <MDTypography variant="button" color="text">
                                            Standard original document
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDBox
                                sx={selectionCardSx(selectedPrintType === "seawaybill")}
                                onClick={() => setSelectedPrintType("seawaybill")}
                            >
                                <MDBox display="flex" alignItems="center" gap={1.5}>
                                    <MDBox
                                        sx={{
                                            width: 46,
                                            height: 46,
                                            borderRadius: "12px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "rgba(25,118,210,0.12)",
                                            color: "#1976d2",
                                        }}
                                    >
                                        <LocalShippingOutlinedIcon />
                                    </MDBox>

                                    <MDBox>
                                        <MDTypography variant="h6" fontWeight="bold">
                                            Seawaybill
                                        </MDTypography>
                                        <MDTypography variant="button" color="text">
                                            Non-negotiable waybill
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Grid>
                    </Grid>
                    <MDBox mt={3}>
                        <Autocomplete
                            freeSolo
                            options={utikadNumberOptions}
                            value={
                                documentTopRightNumber
                                    ? utikadNumberOptions.find(
                                    (opt) => opt.label === documentTopRightNumber
                                ) || documentTopRightNumber
                                    : null
                            }
                            inputValue={documentTopRightNumber || ""}
                            onInputChange={(_e, newInputValue) => {
                                setDocumentTopRightNumber(newInputValue || "");
                            }}
                            onChange={(_e, newValue) => {
                                if (typeof newValue === "string") {
                                    setDocumentTopRightNumber(newValue);
                                } else {
                                    setDocumentTopRightNumber(newValue?.label || "");
                                }
                            }}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option?.label || ""
                            }
                            isOptionEqualToValue={(option, value) => {
                                const optLabel = typeof option === "string" ? option : option?.label;
                                const valLabel = typeof value === "string" ? value : value?.label;
                                return optLabel === valLabel;
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Air Carrier MBL Number"
                                    placeholder="Select or type Air Carrier MBL Number"
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "14px",
                                            backgroundColor: "#fff",
                                        },
                                    }}
                                />
                            )}
                        />

                        <MDTypography
                            variant="caption"
                            color="text"
                            sx={{ mt: 1, display: "block" }}
                        >
                            This value will replace the original number on the selected document.
                        </MDTypography>
                    </MDBox>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 2,
                        backgroundColor: "#fff",
                        borderTop: "1px solid #eef2f7",
                        justifyContent: "space-between",
                    }}
                >
                    <MDButton variant="outlined" color="dark" onClick={handleClosePrintDialog}>
                        Cancel
                    </MDButton>

                    <MDBox display="flex" gap={1}>
                        <MDButton
                            variant="outlined"
                            color="info"
                            onClick={handlePreviewSelectedDocument}
                            disabled={printLoading || !hasData}
                        >
                            {printLoading ? "Preparing..." : "Preview"}
                        </MDButton>

                        <MDButton
                            variant="contained"
                            color="info"
                            onClick={handleDownloadSelectedDocument}
                            disabled={printLoading || !hasData}
                        >
                            {printLoading ? "Preparing..." : "Download PDF"}
                        </MDButton>
                    </MDBox>
                </DialogActions>
            </Dialog>

            <Dialog
                open={previewDialogOpen}
                onClose={handleClosePreviewDialog}
                maxWidth="lg"
                fullWidth
                TransitionComponent={Fade}
                PaperProps={{
                    sx: {
                        ...dialogPaperSx,
                        borderRadius: "22px",
                    },
                }}
            >
                <MDBox
                    sx={{
                        px: 3,
                        py: 2.5,
                        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
                        color: "#fff",
                        position: "relative",
                    }}
                >
                    <MDTypography variant="h5" fontWeight="bold" color="white">
                        {selectedPrintType === "original" ? "Original Preview" : "Seawaybill Preview"}
                    </MDTypography>

                    <MDTypography variant="button" color="white" sx={{ opacity: 0.8 }}>
                        Your merged PDF is ready for review and download
                    </MDTypography>

                    <IconButton
                        onClick={handleClosePreviewDialog}
                        sx={{
                            position: "absolute",
                            right: 14,
                            top: 14,
                            color: "#fff",
                            backgroundColor: "rgba(255,255,255,0.10)",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.18)",
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </MDBox>

                <DialogContent
                    dividers
                    sx={{
                        p: 2,
                        backgroundColor: "#f8fafc",
                        borderTop: "none",
                        borderBottom: "none",
                    }}
                >
                    <MDBox
                        sx={{
                            borderRadius: "16px",
                            overflow: "hidden",
                            backgroundColor: "#fff",
                            boxShadow: "0 8px 30px rgba(15,23,42,0.08)",
                            border: "1px solid #e2e8f0",
                        }}
                    >
                        {previewMergedPdfUrl ? (
                            <iframe
                                src={previewMergedPdfUrl}
                                title="Merged PDF Preview"
                                width="100%"
                                height="760"
                                style={{
                                    border: "none",
                                    display: "block",
                                    background: "#fff",
                                }}
                            />
                        ) : null}
                    </MDBox>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 2,
                        backgroundColor: "#fff",
                        borderTop: "1px solid #eef2f7",
                        justifyContent: "space-between",
                    }}
                >
                    <MDButton variant="outlined" color="dark" onClick={handleClosePreviewDialog}>
                        Close
                    </MDButton>

                    <MDButton
                        variant="contained"
                        color="success"
                        onClick={handleDownloadSelectedDocument}
                        disabled={printLoading}
                    >
                        {printLoading ? "Preparing..." : "Download PDF"}
                    </MDButton>
                </DialogActions>
            </Dialog>

            <LocationPickerModal
                open={pickupPickerOpen}
                title="Add Location History Point"
                valueLatLng={null}
                onClose={() => setPickupPickerOpen(false)}
                onSelect={async (latlng) => {
                    try {
                        const res = await fetch(
                            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latlng.lat}&lon=${latlng.lng}`
                        );

                        const data = await res.json();

                        const city =
                            data.address.city ||
                            data.address.town ||
                            data.address.village ||
                            data.address.state ||
                            "";

                        const country = data.address.country || "";

                        const label = [city, country].filter(Boolean).join(", ");

                        setLocationHistory((prev) => [
                            ...(Array.isArray(prev) ? prev : []),
                            {
                                label: label || `${latlng.lat}, ${latlng.lng}`,
                                lat: latlng.lat,
                                lon: latlng.lng,
                                addedAt: new Date().toISOString(),
                            },
                        ]);
                    } catch (err) {
                        console.error("reverse geocode error", err);
                    }

                    setPickupPickerOpen(false);
                    setRefreshLocationHistory((x) => !x);
                }}
            />

            <LocationPickerModal
                open={deliveryPickerOpen}
                title="Select Delivery Location"
                valueLatLng={deliveryLatLng}
                onClose={() => setDeliveryPickerOpen(false)}
                onSelect={async (latlng) => {
                    try {
                        const res = await fetch(
                            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latlng.lat}&lon=${latlng.lng}`
                        );

                        const data = await res.json();

                        const city =
                            data.address.city ||
                            data.address.town ||
                            data.address.village ||
                            data.address.state ||
                            "";

                        const country = data.address.country || "";

                        setLocationHistory((prev) => {
                            const safePrev = Array.isArray(prev) ? prev : [];

                            return [
                                ...safePrev,
                                {
                                    type: "delivery",
                                    eventType: "Delivery Address",
                                    label: [city, country].filter(Boolean).join(", ") || `${latlng.lat}, ${latlng.lng}`,
                                    lat: latlng.lat,
                                    lon: latlng.lng,
                                    addedAt: new Date().toISOString(),
                                },
                            ];
                        });
                    } catch (err) {
                        console.error("Reverse geocode error", err);
                    }

                    setDeliveryPickerOpen(false);
                    setRefreshLocationHistory((x) => !x);
                }}
            />
            <Dialog
                open={invoiceDialogOpen}
                onClose={() => setInvoiceDialogOpen(false)}
                maxWidth="xl"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        minHeight: "90vh",
                    },
                }}
            >
                <DialogContent sx={{ p: 3 }}>
                    {invoiceState && (
                        <ViewShipments
                            embedded
                            invoiceState={invoiceState}
                            onClose={() => setInvoiceDialogOpen(false)}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );

            if (embedded) {
                              return (
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
        {content}
        {dialogs}
        </LocalizationProvider>
    );
}

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
            <DashboardLayout>
                <DashboardNavbar />

                {content}



                <Footer />

                {dialogs}
            </DashboardLayout>
        </LocalizationProvider>
    );
};

export default ConnectAMBL;